import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  TeeTimeSlot,
  TeeTimeSlotDisplay,
  ClubCourseData,
  PlayerData,
  TeeTimeBooking,
  ClubInfo,
  TeeTimeClubVoucher,
  TeeTimeBookingDiscount,
  TeeTimeClubVoucherSeries,
  PlayerTypes,
  DiscountPlayerClub,
  TeeTimeDiscount,
  TeeTimeBookingPlayer,
  PlayerDiscountProgram,
  DiscountCompany,
  DiscountCompanyProgram,
  BookingPlayerTypeDistribution,
  PlayerBookingTypeAssociation,
  PartnerProgramMembershipApplication,
  PartnerProgramMembershipApplicationPage,
  PlayerInsurance,
  ClubData,
  PlayerInfo,
  TeeTimeClubVoucherPage,
  PlayerHomeInfo,
} from 'src/data/mygolf.data';
import {
  CourseInfo,
  CourseHoleInfo,
  createCourseInfo,
  createClubInfo,
} from 'src/data/club-course';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import {
  ActionSheetController,
  AlertController,
  IonContent,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import {
  ImageService,
  ImageData,
} from 'src/providers/image-service/image-service';
import { ContentType } from 'src/remote-request';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import * as moment from 'moment';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { AddPlayerTypeDiscountPage } from './add-player-type-discount/add-player-type-discount.page';
import { RecentClubPage } from '../../performance/recent-club/recent-club.page';
import { JsonService } from 'src/json-util';
import { ImageZoomPage } from '../image-zoom/image-zoom.page';
import { AddPlayerListPage } from '../add-player-list/add-player-list.page';

import { Router } from '@angular/router';
import { HandicapMembershipAddPage } from '../handicap-membership/handicap-membership-add/handicap-membership-add.page';
import { Observable } from 'rxjs';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { PlayerListPage } from '../player-list/player-list.page';
import { InsuranceModalComponent } from './insurance-modal/insurance-modal.component';
import { CommonPullupMenuComponent } from '../common-pullup-menu/common-pullup-menu.component';
import { filter, map, take } from 'rxjs/operators';

@Component({
  selector: 'app-player-voucher',
  templateUrl: './player-voucher.page.html',
  styleUrls: ['./player-voucher.page.scss'],
})
export class PlayerVoucherPage implements OnInit {
  courses: Array<CourseInfo>;
  clubId: number;
  forDate: string;
  isClub: boolean = false;
  courseId: number;
  teeSlot: Array<TeeTimeSlotDisplay>;
  startCourses: Array<ClubCourseData>;
  changeType: string;
  currentSlot: TeeTimeBooking;
  color: string;
  currentTime: string;
  mode: string;
  @Input() type: string;
  optionTypes: string = 'discount';// 'voucher';
  fromClub: boolean = false;
  forBooking: boolean = false;
  player: PlayerData;
  clubInfo: ClubData;
  // clubInfo: any;
  who: string;
  // player: PlayerInfo;
  // mode: string;
  playerVoucher: Array<TeeTimeClubVoucher>;
  voucherUsed: Array<TeeTimeClubVoucher>;
  bookingId: number;
  searchVoucher: string;
  bookingDiscounts: Array<TeeTimeBookingDiscount>;
  appliedVouchers: Array<TeeTimeClubVoucher> = new Array<TeeTimeClubVoucher>();
  clubData: ClubInfo = null;

  courseInfo: CourseInfo;
  isVoucherApplied: boolean = false;

  showVoucherActive: boolean = false;
  playerProfiles: Array<any>;

  playerTypes: Array<any>;

  playerActiveClubDiscount: Array<TeeTimeDiscount>;
  applicableClubDiscount: Array<TeeTimeDiscount>;
  discountUsed: Array<TeeTimeDiscount>;
  bookingPlayer: TeeTimeBookingPlayer;
  appliedBookingDiscounts: Array<TeeTimeBookingDiscount>;
  overrideProfiles: Array<any> = new Array<any>();
  seriesClubInfo: Array<any>;
  voucherSeries: Array<TeeTimeClubVoucherSeries>;
  playerDiscountPrograms: Array<PlayerDiscountProgram>;
  pendingPDP: Array<PlayerDiscountProgram> = new Array<PlayerDiscountProgram>();

  showPlayerCard: boolean = false;
  activeClubDiscounts: Array<any> = new Array<any>();

  playerPendingDP: Array<PlayerDiscountProgram> =
    new Array<PlayerDiscountProgram>();
  playerApprovedDP: Array<PlayerDiscountProgram> =
    new Array<PlayerDiscountProgram>();

  assignedPlayerProfiles: Array<PlayerBookingTypeAssociation> =
    new Array<PlayerBookingTypeAssociation>();

  transferMode: boolean = false;
  selVoucherSeries: TeeTimeClubVoucherSeries;
  appAttribute: any;
  title: string = 'Deals Options';
  //   assert.equal(NoYes.No, 'No');
  //   assert.equal(NoYes.Yes, 'Yes');
  showPendingOnly: boolean = false;

  partnerId: string;
  newMode: boolean = false;
  application: PartnerProgramMembershipApplication;
  playerHasInsurance: boolean = false;
  player$: Observable<PlayerInfo>;
  playerHomeInfo$: Observable<PlayerHomeInfo>;
  fromPartner: DiscountCompany = null;
  partnerInfo: DiscountCompany;
  disableAll: string = 'no';
  dataExtras: any;

  voucherTypes: string = 'booking';
  voucherView: string = 'available'; // | 'expired' | 'redeemed';
  constructor(
    private flightService: ClubFlightService,
    private navParams: NavParams,
    private toastCtl: ToastController,
    private platform: Platform,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private loadingCtl: LoadingController,
    private imageService: ImageService,
    private playerHomeActions: PlayerHomeActions,
    private actionSheetCtl: ActionSheetController,
    private router: Router,
    private mg2uUtil: mygolfUtils,
    private popoverCtl: PopoverController,
    private playerHomeService: PlayerHomeDataService,
  ) {
    this.dataExtras = this.router.getCurrentNavigation()?.extras?.state;
    if (this.dataExtras) {
      this.courses = this.dataExtras.courses;
      this.clubId = this.dataExtras.clubId;
      this.forDate = this.dataExtras.forDate;
      this.courseId = this.dataExtras.courseId;
      this.changeType = this.dataExtras.changeType;
      this.currentSlot = this.dataExtras.currentSlot;

      this.mode = this.dataExtras.mode;
      this.type = this.dataExtras.type;
      this.fromClub = this.dataExtras.fromClub;
      this.forBooking = this.dataExtras.forBooking;
      this.player = this.dataExtras.player;
      this.clubInfo = this.dataExtras.clubInfo;
      this.who = this.dataExtras.who;
      this.title = this.dataExtras.title;
      this.bookingId = this.dataExtras.bookingId;
      this.bookingDiscounts = this.dataExtras.appliedVouchers;
      //   this.bookingDiscounts = navParams.get('bookingDiscounts');

      this.partnerId = this.dataExtras.partnerId;
      this.newMode = this.dataExtras.newMode;
      this.application = this.dataExtras.application;
      this.player$ = this.dataExtras.player$;

      this.partnerId = this.dataExtras.partnerId;
      this.playerTypes = this.dataExtras.playerTypes;
      this.fromPartner = this.dataExtras.fromPartner;
      if (this.dataExtras.disableAll === 'yes')
        this.disableAll = this.dataExtras.disableAll;
      if (
        this.dataExtras.partnerInfo !== undefined ||
        this.mg2uUtil.getPartnerInfo() !== undefined
      ) {
        this.partnerInfo =
          this.dataExtras.partnerInfo || this.mg2uUtil.getPartnerInfo();
      }
      this.bookingPlayer = this.dataExtras.bookingPlayer;
      this.showPlayerCard = this.dataExtras.showPlayerCard;
      this.appliedBookingDiscounts = this.dataExtras.bookingDiscounts;
    } else {
      this.courses = navParams.get('courses');
      this.clubId = navParams.get('clubId');
      this.forDate = navParams.get('forDate');
      this.courseId = navParams.get('courseId');
      this.changeType = navParams.get('changeType');
      this.currentSlot = navParams.get('currentSlot');

      this.mode = navParams.get('mode');
      this.type = navParams.get('type');
      this.fromClub = navParams.get('fromClub');
      this.forBooking = navParams.get('forBooking');
      this.player = navParams.get('player');
      this.clubInfo = navParams.get('clubInfo');
      this.who = navParams.get('who');
      this.title = navParams.get('title');
      this.bookingId = navParams.get('bookingId');
      this.bookingDiscounts = navParams.get('appliedVouchers');
      //   this.bookingDiscounts = navParams.get('bookingDiscounts');

      this.partnerId = navParams.get('partnerId');
      this.newMode = navParams.get('newMode');
      this.application = navParams.get('application');
      this.player$ = navParams.get('player$');

      this.partnerId = navParams.get('partnerId');
      this.playerTypes = navParams.get('playerTypes');
      this.fromPartner = navParams.get('fromPartner');
      if (navParams.get('disableAll') === 'yes')
        this.disableAll = navParams.get('disableAll');
      if (
        navParams.get('partnerInfo') !== undefined ||
        this.mg2uUtil.getPartnerInfo() !== undefined
      ) {
        this.partnerInfo =
          navParams.get('partnerInfo') || this.mg2uUtil.getPartnerInfo();
      }
      this.bookingPlayer = this.navParams.get('bookingPlayer');
      this.showPlayerCard = this.navParams.get('showPlayerCard');
      this.appliedBookingDiscounts = this.navParams.get('bookingDiscounts');
    }
    if (this.changeType && this.changeType === 'slot') this.isClub = false;
    else if (this.changeType && this.changeType === 'course')
      this.isClub = true;
    if (this.bookingDiscounts) {
      this.appliedVouchers = this.bookingDiscounts
        .filter((d: TeeTimeBookingDiscount) => {
          if (this.player && this.player.id)
            return (
              d.voucherApplied &&
              d.voucherApplied.playerAssigned.id === this.player.id
            );
        })
        .map((d: TeeTimeBookingDiscount) => {
          return d.voucherApplied;
        });
    }

    // this.playerTypes = [{
    //     id: "ARMY",
    //     name: "Armed Forces",
    //     use: true,
    // },
    // {
    //     id: "GOVT",
    //     name: "Government",
    //     use: true,
    // },
    // {
    //     id: "GUEST",
    //     name: "Member's Guest",
    //     use: false,
    // },
    // {
    //     id: "JUNIOR",
    //     name: "Junior",
    //     use: true,
    // },
    // {
    //     id: "MEMBER",
    //     name: "Club Member",
    //     use: true,
    // },
    // {
    //     id: "POLICE",
    //     name: "Police",
    //     use: true,
    // },
    // {
    //     id: "SENIOR",
    //     name: "Senior Citizen",
    //     use: true,
    // },
    // {
    //     id: "STAFF",
    //     name: "Staff",
    //     use: true,
    // }, {
    //     id: "TMEMBER",
    //     name: "Term Member",
    //     use: true,
    // },
    // ]
    if (this.playerTypes) {
      this.playerTypes.sort((a, b) => {
        if (a.name < b.name) return -1;
        else if (a.name > b.name) return 1;
        else return 0;
      });
    }

    if (this.appliedBookingDiscounts)
      this.appliedBookingDiscounts = this.appliedBookingDiscounts.filter(
        (bd) => {
          return !bd.voucherApplied;
        }
      );
    if (this.currentSlot && this.currentSlot.priceMap) {
      let _priceMap = this.currentSlot.priceMap;
      for (let key in _priceMap) {
        this.overrideProfiles.push(key);
      }

      this.overrideProfiles = this.overrideProfiles.filter((value) => {
        return value !== 'MEMBER';
      });
    }

    if (this.who === 'player' && this.forBooking) {
      if (this.type === 'voucher') {
        this.optionTypes = 'voucher';
        this.getListPlayerVoucher();
      } else if (this.type === 'types') {
        // this.setOptionType(1);
      } else if (this.type === 'discount') {
        this.setOptionType(2);
      } else if (this.type === 'insurance') {
        this.setOptionType(4);
      }
    } else if (this.who === 'club' && this.forBooking) {
      if (this.type === 'voucher') {
        this.setOptionType(3);
      } else if (this.type === 'types') {
        this.setOptionType(1);
      } else if (this.type === 'discount') {
        this.setOptionType(2);
      } else if (this.type === 'insurance') {
        this.setOptionType(4);
      }
    } else {
      if (this.type === 'voucher') {
        this.setOptionType(3);
      } else if (this.type === 'types') {
        this.setOptionType(1);
      } else if (this.type === 'discount') {
        this.setOptionType(2);
      } else if (this.type === 'handicap') {
        this.setOptionType(5);
      } else if (this.type === 'insurance') {
        this.setOptionType(4);
      }
    }
    if (this.type !== 'handicap') {
      this.title = 'Deals Options';
    }

    if (this.type === 'handicap') {
      if (this.newMode)
        this.onAddHandicapMembership(
          this.application ? true : false,
          this.application
        );
    }

    if(!this.player$) {

      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$.pipe(filter(Boolean)).pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
    }
  }
  ngOnInit() { }

  getVisibleMode(optionType?: string) {
    switch (optionType) {
      case 'types':
        if (this.mode === 'apply' && this.fromClub && this.forBooking)
          return true;
        else if (this.mode === 'apply' && !this.fromClub && this.forBooking)
          return false;
        else return true;
      // break;
      case 'discount':
        if (this.mode === 'apply' && this.fromClub && this.forBooking)
          return true;
        else if (this.mode === 'apply' && !this.fromClub && this.forBooking)
          return true;
        else if (this.type === 'membership') {
          let _canView: boolean = false;
          if (this.fromPartner) {
            this.fromPartner.partnerServices
              .filter((service) => {
                return service.toLowerCase().includes('discount');
              })
              .map((s) => {
                _canView = true;
              });
            return _canView;
          } else return false;
        } else if (this.type === 'handicap') return false;
        else return true;
      case 'voucher':
        if (this.mode === 'apply' && this.fromClub && this.forBooking)
          return true;
        else if (this.mode === 'apply' && !this.fromClub && this.forBooking)
          return true;
        else if (this.type === 'handicap') return false;
        else if (this.type === 'membership' && this.fromPartner) return false;
        else return true;
      case 'insurance':
        if (this.fromClub && !this.player) return false;
        if (this.fromClub) return true;
        else if (this.mode === 'apply' && this.fromClub && this.forBooking)
          return true;
        else if (this.mode === 'apply' && !this.fromClub && this.forBooking)
          return true;
        else if (this.type === 'handicap') return false;
        else if (this.type === 'membership') {
          let _canView: boolean = false;
          if (this.fromPartner) {
            this.fromPartner.partnerServices
              .filter((service) => {
                return service.toLowerCase().includes('insurance');
              })
              .map((s) => {
                _canView = true;
              });
            return _canView;
          } else return false;
        } else return true;
      case 'handicap':
        if (this.type === 'handicap') return true;
        else if (this.type === 'membership') {
          let _canView: boolean = false;
          if (this.fromPartner) {
            this.fromPartner.partnerServices
              .filter((service) => {
                return service.toLowerCase().includes('nga_membership');
              })
              .map((s) => {
                _canView = true;
              });
            return _canView;
          } else return false;
        } else return false;
    }
  }

  getDisabledMode(optionType?: string) {
    switch (optionType) {
      case 'types':
        if (this.mode === 'apply' && !this.forBooking) return true;
        else if (this.mode === 'apply' && this.forBooking && this.fromClub)
          return false;
        else if (this.mode === 'apply' && this.forBooking && !this.fromClub)
          return true;
        // else if(this.mode === 'manage' && this.forBooking) return true
        else if (this.mode !== 'apply' && !this.forBooking) return false;
        else return true;
      case 'discount':
        if (this.mode === 'apply' && !this.forBooking) return false;
        else return false;
      case 'voucher':
        if (this.mode === 'apply' && !this.forBooking) return false;
        else return false;
      case 'insurance':
        if (this.fromClub) return false;
        else if (this.mode === 'apply' && this.fromClub && this.forBooking)
          return false;
        else if (this.mode === 'apply' && !this.fromClub && this.forBooking)
          return false;
        else if (this.mode === 'apply') return true;
        else return false;
      case 'handicap':
        if (this.type === 'handicap') return false;
        else return false;
    }
  }

  close() {
    let _needRefresh = this.isVoucherApplied;
    this.modalCtrl.dismiss({
      needRefresh: _needRefresh,
    });
  }

  selectHole(hole: CourseHoleInfo, whichNine: number) {
    this.modalCtrl.dismiss({
      hole: hole,
      whichNine: whichNine,
    });
  }

  getTeeTimeBookingList() {
    let _clubCourseId;
    this.startCourses = [];
    _clubCourseId = this.isClub ? this.clubId : this.courseId;
    this.flightService
      .getTeeTimeSlot(this.forDate, this.isClub, _clubCourseId)
      .subscribe((data: Array<TeeTimeSlotDisplay>) => {
        this.teeSlot = data;
        if (this.changeType === 'course') {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return (
              tee.slot.teeOffTime ===
              this.currentSlot.slotAssigned.teeOffTime &&
              tee.slot.startCourse.id !==
              this.currentSlot.slotAssigned.startCourse.id
            );
          });
        } else {
          this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
            return (
              tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
            );
          });
        }

        this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
          this.startCourses.push(t.slot.startCourse);
        });

        this.startCourses = this.getUnique(this.startCourses, 'id');
        this.startCourses.sort((a, b) => {
          if (a.displayOrder < b.displayOrder) return -1;
          if (a.displayOrder > b.displayOrder) return 1;
          else 0;
        });
      });
  }

  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }

  changeSlot(slot: TeeTimeSlotDisplay, type?: string) {
    if (!slot.available && type === 'slot') return false;
    this.flightService
      .getBookingFlightList(
        this.clubId,
        moment(slot.slot.teeOffDate).format('YYYY-MM-DD'),
        true
      )
      .subscribe((data) => {
        let _flightList: Array<TeeTimeBooking>;
        let _hasFlight: Array<TeeTimeBooking>;
        if (data) {
          _flightList = data.flightList;
          _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
            return (
              t.slotAssigned.slotNo === slot.slot.slotNo &&
              t.slotAssigned.slotDayId === slot.slot.slotDayId
            );
          });
        }
        if (_hasFlight && _hasFlight.length > 0) {
          if (
            _hasFlight[0].flight &&
            _hasFlight[0].flight.status === 'PlayFinished'
          ) {
            MessageDisplayUtil.showMessageToast(
              'There is Finished Flight in this slot. Please choose different slot.',
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          } else {
            this.modalCtrl.dismiss({
              newSlot: slot,
              currentSlot: this.currentSlot,
            });
          }
        } else {
          this.modalCtrl.dismiss({
            newSlot: slot,
            currentSlot: this.currentSlot,
          });
        }
      });
  }
  getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
    switch (attribute) {
      case 'time':
        let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
        return _time;
    }
  }

  getCurrentSlotDetails(attribute) {
    switch (attribute) {
      case 'time':
        let _time = moment(
          this.currentSlot.slotAssigned.teeOffTime,
          'HH:mm:ss'
        ).format('hh:mm A');
        return _time;
      case 'courseName':
        let _courseName = this.currentSlot.slotAssigned.startCourse.name;
        return _courseName;
    }
  }

  getSlotClass(slot: TeeTimeSlotDisplay) {
    if (this.changeType === 'course') return 'slot-available';
    else {
      // return this.color
      if (slot.available) return 'slot-available';
      else return 'slot-not-available';
    }
  }

  async setOptionType(type: number) {
    if (type === 1) {
      this.optionTypes = 'types';
      if (this.mode === 'apply' && this.forBooking) {
        this.getApplicablePlayerProfiles();
        this.getAssignedPlayerTypes();
      } else if (this.mode !== 'apply') {
        this.getAssignedPlayerTypes();
      }
    }
    if (type === 2) {
      this.optionTypes = 'discount';

      let loader = await this.loadingCtl.create({
        message: 'Getting Discounts...',
        showBackdrop: false,
        duration: 5000,
      });
      await loader.present();
      if (this.mode === 'apply' && this.forBooking) {
        this.getBookingFlight();
        this.getApplicableDiscountsForPlayer();
        this.getApplicableDiscounts();
        this.getPendingPlayerDiscountCard('approved');
      }
      this.getPlayerDiscountPrograms(loader);
    }
    if (type === 3) {
      this.getListPlayerVoucher();
      if (this.mode === 'apply' && this.forBooking) {
        this.getBookingFlight();
      }
      this.optionTypes = 'voucher';
    }
    if (type === 4) {
      this.optionTypes = 'insurance';
      this.getListPlayerInsurance();
    }

    if (type === 5) {
      let loader = await this.loadingCtl.create({
        message: 'Getting Memberships...',
        showBackdrop: false,
        duration: 5000,
      });
      loader.present();
      this.onRefreshHandicapMembership();
      if (!this.fromClub) this.getPlayerDiscountPrograms(loader);
      this.optionTypes = 'handicap';
    }
  }
  async onApprovalList(pdp: PlayerDiscountProgram, type?: string) {
    let headerTitle;
    switch (type) {
      case 'playerDiscount':
        headerTitle = 'Privilege Card Approval List';
        // MessageDisplayUtil.showErrorToast('This feature is not yet supported', this.platform, this.toastCtl,
        //     5000, "bottom");
        break;
    }
    let typeModal = await this.modalCtrl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type,
        mode: 'approval',
        pdp: pdp,
        player: this.player,
      },
    });
    typeModal.present();
  }

  async onEditClick(pdp: PlayerDiscountProgram, type?: string) {
    let headerTitle;
    switch (type) {
      case 'playerType':
        headerTitle = 'Edit Player Type';
        MessageDisplayUtil.showErrorToast(
          'This feature is not yet supported',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        break;
      case 'playerDiscount':
        headerTitle = 'Edit Privilege Card';
        break;
      case 'playerVoucher':
        headerTitle = 'Manage Voucher(s)';
        break;
      case 'playerInsurance':
        headerTitle = 'Edit Player Insurance';
        break;
    }
    let typeModal = await this.modalCtrl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type,
        mode: 'edit',
        pdp: pdp,
        playerInsurance: pdp,
        player: this.player,
        fromClub: this.fromClub,
        clubId: this.clubInfo && this.clubInfo.id ? this.clubInfo.id : null,
      },
    });
    let _deleteMultiDone: boolean = false;
    typeModal.onDidDismiss().then((data: any) => {

      if (data?.data?.created) {
        if (this.optionTypes === 'insurance') this.setOptionType(4);
        else this.setOptionType(2);
      }
    });
    typeModal.present();
  }

  async onAddClick(type?: string) {
    let headerTitle;
    let _data;
    switch (type) {
      case 'playerType':
        headerTitle = 'Add Player Type';
        break;
      case 'playerDiscount':
        headerTitle = 'Add Discount Card';
        _data = this.playerDiscountPrograms;
        break;
      case 'playerVoucher':
        headerTitle = 'Manage Voucher(s)';
        break;
      case 'playerInsurance':
        headerTitle = 'Add Player Insurance';
        break;
    }
    console.debug("on add click ", headerTitle, type)
    let typeModal = await this.modalCtrl.create({
      component: AddPlayerTypeDiscountPage,
      componentProps: {
        headerTitle: headerTitle,
        type: type, //playerType, playerDiscount, playerVoucher
        mode: 'new', //new edit
        player: this.player,
        forBooking: this.forBooking,
        fromClub: this.fromClub,
        clubId: this.clubInfo && this.clubInfo.id ? this.clubInfo.id : null,
        data: _data,
      },
    });

    let _deleteMultiDone: boolean = false;
    typeModal.onDidDismiss().then((data: any) => {
      //
      if (data && data.data && data?.data?.created) {
        setTimeout(() => {
          // this.getPlayerDiscountPrograms();
          if (type === 'playerType') this.setOptionType(1);
          else if (type === 'playerInsurance') this.setOptionType(4);
          else if (type === 'playerDiscount') this.setOptionType(2);
        }, 1000);
      }
    });
    typeModal.present();
  }

  async onRemoveClick(data: any, type?: string) {
    // let headerTitle;
    // let message;
    // switch (type) {
    //   case 'playerType':
    //     headerTitle = 'Removing Player Type';
    //     message = 'Do you want to remove selected Player Type?';
    //     break;
    //   case 'playerDiscount':
    //     headerTitle = 'Removing Discount Card';
    //     message =
    //       'You will lose privilege/discount deals by the club. Do you want to proceed?';
    //     break;
    //   case 'playerVoucher':
    //     headerTitle = 'Removing Voucher';
    //     message = 'Do you want to remove selected Voucher?';
    //     break;
    //   case 'playerInsurance':
    //     headerTitle = 'Removing Insurance';
    //     message = 'Do you want to remove selected Insurance?';
    //     break;
    // }
    // let prompt = await this.alertCtrl.create({
    //   header: headerTitle,
    //   message: message,
    //   buttons: [
    //     {
    //       text: 'No',
    //       // handler: data => {
    //     },
    //     {
    //       text: 'Yes',
    //       handler: () => {
    //         if (type === 'playerInsurance') this.goRemoveInsurance(data);
    //         else this.goRemoveDiscount(data);
    //       },
    //     },
    //   ],
    // });
    // prompt.present();

    if (type === 'playerInsurance') this.goRemoveInsurance(data);
    else this.goRemoveDiscount(data);
  }
  goRemoveInsurance(insurance: PlayerInsurance) {
    let _insuranceId;
    let _playerId: number;

    if (this.player) _playerId = this.player.id | this.player.playerId;
    if (insurance) _insuranceId = insurance.id;
    this.flightService.deletePlayerInsurance(_playerId, _insuranceId).subscribe(
      (data) => {
        //
        if (data) {
          MessageDisplayUtil.showMessageToast(
            'Successfully removed player insurance card',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          this.getListPlayerInsurance();
          return false;
        }
      },
      (error) => {
        let _error = error.json();
        let _msg;
        // _msg = _error.error;
        _msg =
          'Encountered error in removing player insurance. Please contact myGolf2u support.';
        MessageDisplayUtil.showMessageToast(
          _msg,
          this.platform,
          this.toastCtl,
          7000,
          'bottom'
        );
        this.getListPlayerInsurance();
        return false;
      },
      () => {
        if (this.forBooking) this.getBookingFlight();
      }
    );
  }
  onSearchVoucherClick() {
    this.playerVoucher = [];
    let _clubId;
    let _playerId;
    if (this.clubInfo) _clubId = this.clubInfo.id;
    if (this.player) _playerId = this.player.playerId;
    this.flightService
      .getListPlayerVouchers(_playerId)
      .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
        if (playerVoucher && playerVoucher.length > 0)
          if (this.searchVoucher && this.searchVoucher.length > 0) {
            this.playerVoucher = playerVoucher.filter(
              (v: TeeTimeClubVoucher) => {
                return (
                  v.voucherNumber
                    .toLowerCase()
                    .includes(this.searchVoucher.toLowerCase()) ||
                  v.name
                    .toLowerCase()
                    .includes(this.searchVoucher.toLowerCase())
                );
              }
            );
          } else this.playerVoucher = playerVoucher;
      });
  }

  getListClubPlayerVoucher(clubId?: number) {
    let _clubId;
    let _playerId;
    this.playerVoucher = [];
    if (clubId) _clubId = clubId;
    else if (this.clubInfo) _clubId = this.clubInfo.id;
    if (this.player) _playerId = this.player.id | this.player.playerId;
    this.flightService
      .getListClubPlayerVouchers(_clubId, _playerId)
      .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
        if (playerVoucher && playerVoucher.length > 0) {
          this.playerVoucher = playerVoucher;
          if (clubId) {
            this.seriesClubInfo = playerVoucher
              .filter((voucher) => {
                if (!voucher.club) return false;
                return voucher.club.id === _clubId;
              })
              .map((v) => {
                return v.club;
              });
          }
        }
      });
  }
  getVoucherApplicableText(voucher: any, type: string) {
    // TeeTimeClubVoucherSeries | TeeTimeClubVoucher
    if (!voucher) return false;
    let _allowText;
    let _applicableStart = 'Applicable on';
    let _allowWeekdays;
    let _allowWeekends;
    let _allowHolidays;
    let _applicableEnd = '';
    let _voucherDetails = voucher;
    if (type === 'allowDays') {
      _allowWeekdays =
        voucher &&
          voucher.allowOnWeekdays &&
          voucher.allowOnWeekends &&
          voucher.allowOnPublicHolidays
          ? 'Weekdays' + ', '
          : voucher && voucher.allowOnWeekdays
            ? 'Weekdays'
            : '';
      _allowWeekends =
        voucher &&
          voucher.allowOnWeekends &&
          voucher.allowOnWeekdays &&
          voucher.allowOnPublicHolidays
          ? 'Weekends'
          : voucher &&
            voucher.allowOnWeekdays &&
            voucher.allowOnWeekends &&
            !voucher.allowOnPublicHolidays
            ? ' and ' + 'Weekends'
            : voucher && !voucher.allowOnWeekdays && voucher.allowOnWeekends
              ? 'Weekends'
              : '';
      _allowHolidays =
        voucher &&
          (voucher.allowOnWeekdays || voucher.allowOnWeekends) &&
          voucher.allowOnPublicHolidays
          ? ' and ' + 'Public Holidays'
          : voucher && voucher.allowOnPublicHolidays
            ? 'Public Holidays'
            : '';

      _allowText =
        _applicableStart +
        ' ' +
        _allowWeekdays +
        _allowWeekends +
        _allowHolidays;
    } else if (type === 'bookingAmount') {
      _allowText = 'Covers ';
      if (
        !_voucherDetails.priceComps ||
        _voucherDetails.priceComps.length === 0
      )
        _allowText += 'Booking Amount';
      else {
        let _buggyFee = _voucherDetails.priceComps.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'buggyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hbuggyfee')
            return true;
          else return false;
        });

        let _caddyFee = _voucherDetails.priceComps.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'caddyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hcaddyfee')
            return true;
          else return false;
        });
        _voucherDetails.priceComps = _voucherDetails.priceComps.filter(
          (price) => {
            if (_buggyFee.length === 2)
              return price.priceComponent.id.toLowerCase() !== 'hbuggyfee';
            if (_caddyFee.length === 2)
              return price.priceComponent.id.toLowerCase() !== 'hcaddyfee';
            else return true;
          }
        );

        // if(!_discountDetails.priceComponents || _discountDetails.priceComponents.length === 0) return '';
        if (
          _voucherDetails &&
          _voucherDetails.priceComponents &&
          _voucherDetails.priceComponents.length > 0
        )
          _allowText += _voucherDetails.priceComponents
            .map((a) => {
              return a.priceComponent.name;
            })
            .reduce((a, b) => {
              return a + ', ' + b;
            });
      }
    } else if (type === 'flight') {
      _allowText = 'Applicable for this flight';
    }
    return _allowText;
  }

  async onUseThisVoucher(voucher: TeeTimeClubVoucher) {
    let prompt = await this.alertCtrl.create({
      header: 'Use Voucher',
      message:
        'This will apply voucher to current booking flight. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.goUseThisVoucher(voucher);
            prompt.dismiss();
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  getSingleVoucher(v: TeeTimeClubVoucherSeries) {
    let _voucherSeries = v;
    let _selectedVoucher: TeeTimeClubVoucher;
    let _playerVoucher: Array<TeeTimeClubVoucher>;
    _playerVoucher
      .filter((v: TeeTimeClubVoucher) => {
        return v.seriesId === _voucherSeries.id;
      })
      .map((v: TeeTimeClubVoucher) => {
        _selectedVoucher = v;
      });
  }

  goUseThisVoucher(voucher: TeeTimeClubVoucher) {
    let _voucherUsed: boolean = false;
    if (this.voucherUsed && this.voucherUsed.length > 0) _voucherUsed = true;
    // if(!this.appliedVouchers || (this.appliedVouchers && this.appliedVouchers.length === 0)) return false;

    let _voucher = voucher;
    if (!_voucher.usableWithOtherRewards && this.voucherUsed) {
      MessageDisplayUtil.showMessageToast(
        'This voucher cannot be used with any other voucher',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _playerId = this.player.id;

    let _hasApplied = [];
    if (this.appliedVouchers && this.appliedVouchers.length > 0) {
      _hasApplied = this.appliedVouchers.filter((bd) => {
        return (
          bd.playerAssigned.id === _playerId && bd.seriesId === voucher.seriesId
        );
      });
    } else _hasApplied = [];
    if (_hasApplied && _hasApplied.length > 0) {
      MessageDisplayUtil.showMessageToast(
        "This player's voucher has been used for this booking.",
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    let _force: boolean = false;
    this.flightService
      .applyPlayerBookingVoucher(this.bookingId, _voucher.id, _force)
      .subscribe((data: any) => {
        if (data) {
          // this.voucherUsed.push(voucher);

          MessageDisplayUtil.showMessageToast(
            'Successfully applied voucher',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          // this.getListClubPlayerVoucher();
          this.getListPlayerVoucher();
          this.isVoucherApplied = true;
          let _data = data.json();
          let _bookingDiscounts = _data.bookingDiscounts;

          this.appliedVouchers = _bookingDiscounts
            .filter((d: TeeTimeBookingDiscount) => {
              return (
                d.voucherApplied &&
                d.voucherApplied.playerAssigned.id === this.player.id
              );
            })
            .map((d: TeeTimeBookingDiscount) => {
              return d.voucherApplied;
            });
        }
      }),
      (error) => {
        let _error = error.json();

        let _msg =
          _error && _error.errors && _error.errors.length > 0
            ? _error.errors[0]
            : _error.error;
        if (
          _error.errorCode.includes('VoucherNotApplicableWithOtherPromotions')
        )
          _msg =
            'This voucher is not usable with other discounts and vouchers.';
        MessageDisplayUtil.showErrorToast(
          _msg,
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      },
      () => {
        if (this.forBooking) this.getBookingFlight();
      };
  }

  getDateText(date: any) {
    if (date && date.length === 0) return false;
    if (!date) return false;
    let _date = date;
    return moment(_date, 'YYYY-MM-DD').format('DD MMM YYYY');
  }

  async onRemoveThisVoucher(voucher: TeeTimeClubVoucher) {
    let prompt = await this.alertCtrl.create({
      header: 'Remove Voucher',
      message:
        'This will remove voucher from current booking flight. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.goRemoveThisVoucher(voucher);
            prompt.dismiss();
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goRemoveThisVoucher(voucher: TeeTimeClubVoucher, applyVoucher?: any) {
    this.flightService
      .removePlayerBookingVoucher(this.bookingId, voucher.id)
      .subscribe((data: any) => {
        if (data) {
          let _data = data.json();
          let _bookingDiscounts = _data.bookingDiscounts;

          this.appliedVouchers = _bookingDiscounts
            .filter((d: TeeTimeBookingDiscount) => {
              return (
                d.voucherApplied &&
                d.voucherApplied.playerAssigned.id === this.player.id
              );
            })
            .map((d: TeeTimeBookingDiscount) => {
              return d.voucherApplied;
            });
          this.getListPlayerVoucher();
          this.isVoucherApplied = true;
        }
      }),
      async (error) => {
        let _error = error.json();
        let alert = await this.alertCtrl.create({
          header: 'Issue removing voucher',
          message:
            _error && _error.message
              ? _error.message
              : "There's an issue removing voucher. Please try again",
          buttons: ['Close'],
        });
        alert.present();
      },
      () => {
        if (this.forBooking) this.getBookingFlight();
      };
  }

  getListPlayerVoucher() {
    let _clubId;
    if (this.clubInfo) _clubId = this.clubInfo.id;
    let _playerId;
    this.playerVoucher = [];
    if (this.player) _playerId = this.player.id | this.player.playerId;
    this.flightService
      .getListPlayerVouchers(_playerId)
      .subscribe((playerVoucher: Array<TeeTimeClubVoucher>) => {
        if (playerVoucher && playerVoucher.length > 0) {
          this.playerVoucher = playerVoucher;

          if (_clubId) {
            this.seriesClubInfo = playerVoucher
              .filter((voucher) => {
                if (!voucher.club) return false;
                return voucher.club.id === _clubId;
              })
              .map((v) => {
                return v.club;
              });
            if (this.seriesClubInfo && this.seriesClubInfo.length > 0) {
              this.seriesClubInfo = this.getUnique(this.seriesClubInfo, 'id');
              this.seriesClubInfo.forEach((club) => {
                this.getPlayerVoucherSeries(club);
              });
            }
          } else {
            this.seriesClubInfo = playerVoucher.map((v) => {
              return v.club;
            });
            if (this.seriesClubInfo && this.seriesClubInfo.length > 0) {
              this.seriesClubInfo = this.getUnique(this.seriesClubInfo, 'id');
              this.seriesClubInfo.forEach((club) => {
                this.getPlayerVoucherSeries(club);
              });
            }
          }
        }
      });
  }

  getVoucherCurrency(voucher: TeeTimeClubVoucher) {
    let _currencySymbol = '$';
    if(this.clubInfo) _currencySymbol = this.clubInfo?.address?.countryData?.currencySymbol || '$';
    else if(voucher) _currencySymbol = voucher?.club?.address?.countryData?.currencySymbol;
    else _currencySymbol = '$';

    return _currencySymbol
}

  async goClubPicklist() {
    let _courseId;
    let _courseName;
    let club = await this.modalCtrl.create({
      component: RecentClubPage,
      componentProps: {
        courseInfo: this.courseInfo,
        openedModal: true,
        courseType: 'club',
        clubData: this.clubData,
      },
      id: 'RecentClubPage',
    });

    club.onDidDismiss().then((data: any) => {
      if (data && data.data && data.data.clubInfo) {
        this.clubData = data.data.clubInfo;
        this.courseInfo = createCourseInfo();
        this.getListClubPlayerVoucher(this.clubData.clubId);
      }
    });

    club.present();
  }

  getClubName(): string {
    let clubName = 'Tap here to view by Club';
    let _clubName;
    if (this.clubData && this.clubData.clubName) {
      return this.clubData.clubName;
    } else return clubName;
  }
  getClubImage(club: any) {
    if (club) return club.clubImage;
    else './assets/image/default_club.png';
  }

  clearClubPicklist() {
    this.clubData = null;
    this.getListPlayerVoucher();
  }

  getExpiryDate(item: TeeTimeClubVoucher | TeeTimeDiscount, type?: string) {
    if (!item) return '';
    if (item && !item.validFrom && !item.validUntil) return '';
    let _validTill;
    let _validFrom;

    let _today = moment();
    let _voucher;
    if (
      this.playerVoucher &&
      this.playerVoucher.length > 0 &&
      type !== 'discount'
    ) {
      _voucher = this.playerVoucher.filter((voucher) => {
        return voucher.seriesId === item.id;
      });
    }
    switch (type) {
      case 'discount':
        _validTill = moment(item.validUntil);
        _validFrom = moment(item.validFrom);
        break;
      default:
        let _until = moment(item.validUntil);
        if (_until.diff(_today, 'days') < 0) {
          _validTill = moment(item.validUntil);
          _validFrom = moment(item.validFrom);
        } else if (_voucher && _voucher.length > 0) {
          _validTill = moment(_voucher[0].validUntil);
          _validFrom = moment(_voucher[0].validFrom);
        } else {
          _validTill = moment(item.validUntil);
          _validFrom = moment(item.validFrom);
        }
        break;
    }
    let _days = _validTill.diff(_today, 'days');
    let _months = _validTill.diff(_today, 'months');
    let _years = _validTill.diff(_today, 'years');
    if (_days > 0 && _months === 0) return 'Expires in ' + _days + ' day(s)';
    else if (_months > 0 && _years === 0)
      return 'Expires in ' + _months + ' month(s)';
    else if (_years > 0 && _years <= 100)
      return 'Expires in ' + _years + ' year(s)';
    else if (_years > 100) return 'No Expiry';
    else if (_days === 0) return 'Expires today';
    else if (_days < 0) return 'Expired';
    else return 'Expired';
  }

  toggleVoucherActive() {
    this.showVoucherActive = !this.showVoucherActive;
  }

  getVoucherAmountDetails(voucher: TeeTimeClubVoucher) {
    console.debug("get voucher amount details : ", voucher, voucher?.voucherAmountType)
    if (voucher.voucherAmountType === 'Absolute') {
      return (
        'Amount ' +
        this.getVoucherCurrency(voucher) +
        ' ' +
        voucher.voucherAmount
      );
    } else if (voucher.voucherAmountType === 'Fixed' || voucher.voucherAmountType === 'Package') {
      return (
        'Amount ' +
        this.getVoucherCurrency(voucher) +
        ' ' +
        voucher.voucherAmount
      );
    } else if (voucher.voucherAmountType === 'Percentage') {
      return voucher.voucherAmount + '% off';
    } else return false;
  }

  getProgramAmountDetails(program: PlayerDiscountProgram) {
    if (!program || !program.discountProgram.discountCompany.address)
      return false;
    let _currency =
      program.discountProgram.discountCompany.address.countryData
        .currencySymbol;
    let _discountProgram = program.discountProgram;
    if (_discountProgram.amountType === 'Absolute') {
      return 'Save ' + _currency + ' ' + _discountProgram.discountAmount;
    } else if (_discountProgram.amountType === 'Fixed' || _discountProgram.amountType === 'Package') {
      return 'Up to ' + _currency + ' ' + _discountProgram.discountAmount;
    } else if (_discountProgram.amountType === 'Percentage') {
      return _discountProgram.discountAmount + '% off';
    } else return false;
  }

  getPlayerVoucherSeries(clubs: ClubData) {
    this.voucherSeries = [];

    if (this.mode === 'apply' && !this.currentSlot) return false;
    if (
      this.mode === 'apply' &&
      this.currentSlot.slotAssigned &&
      this.currentSlot.slotAssigned.pricingPlanPromotional &&
      !this.currentSlot.slotAssigned.pricingPlanPromotional.discountsApplicable
    )
      return false;

    let _showAll: boolean = false;
    if (this.mode !== 'apply') _showAll = true;
    let voucherSeries: Array<TeeTimeClubVoucherSeries> = [];
    this.flightService
      .getClubVoucherSeries(1, clubs.id, '', null, null, _showAll)
      .subscribe((data: any) => {
        if (data.totalInPage > 0 && data.items && data.items.length > 0) {
          voucherSeries = data.items;
          if (voucherSeries) {
            this.voucherSeries.push(...voucherSeries);
            this.voucherSeries.forEach((vs) => {
              // JsonService.deriveFulImageURL(vs, 'voucherImage');
            });

            this.voucherSeries = this.voucherSeries.sort((a, b) => {
              if (a.club.name < b.club.name) {
                if (a.validUntil < b.validUntil) return 1;
                else if (b.validUntil < a.validUntil) return -1;
                else return -1;
              } else if (a.club.name > b.club.name) {
                if (a.validUntil < b.validUntil) return 1;
                else if (b.validUntil < a.validUntil) return -1;
                else return 1;
              } else return 0;
            });
          }
        }
      });
  }

  getApplicablePlayerProfiles() {
    this.playerProfiles = [];
    let _clubId = this.clubInfo ? this.clubInfo.id : null;
    if (!_clubId) return false;
    if (!this.player) return false;
    let _playerId = this.player.id || this.player.playerId;
    this.flightService
      .getApplicableClubPlayerTypes(_clubId, _playerId)
      .subscribe((data: any) => {
        let _hasProfile;
        this.playerProfiles = data;
        this.playerProfiles.filter((profile) => {
          _hasProfile = this.overrideProfiles.find((override) => {
            if (override === profile) return true;
            else return false;
          });
          return _hasProfile;
        });
      });
  }

  getActiveClubDiscounts() {
    /*** not using this  ********/
    this.playerProfiles = [];
    let _clubId = this.clubInfo ? this.clubInfo.id : null;
    if (!_clubId) return false;
    if (!this.player) return false;
    let _playerId = this.player.id || this.player.playerId;
    let _playerType = this.bookingPlayer.playerType;
    this.flightService
      .getActiveListClubDiscounts(_clubId)
      .subscribe((activeClubDiscounts: Array<TeeTimeDiscount>) => {
        if (activeClubDiscounts) {
          if (this.bookingPlayer.playerType) {
            let _has: boolean = false;
            this.playerActiveClubDiscount = activeClubDiscounts.filter(
              (acd) => {
                acd.playerTypes.filter((pt) => {
                  if (pt.bookingPlayerType.id === _playerType.id) {
                    _has = true;
                    return _has;
                  } else return false;
                });

                return _has;
              }
            );

            if (
              this.appliedBookingDiscounts &&
              this.appliedBookingDiscounts.length > 0
            ) {
              this.playerActiveClubDiscount =
                this.playerActiveClubDiscount.filter((acd) => {
                  let _applied = this.appliedBookingDiscounts.find((td) => {
                    if (acd.id && td.discountApplied.id)
                      return td.discountApplied.id === acd.id;
                  });
                  return !_applied;
                });
            }
          } else {
            this.playerActiveClubDiscount = activeClubDiscounts;
            if (
              this.appliedBookingDiscounts &&
              this.appliedBookingDiscounts.length > 0
            ) {
              this.playerActiveClubDiscount =
                this.playerActiveClubDiscount.filter((acd) => {
                  let _applied = this.appliedBookingDiscounts.find((td) => {
                    if (acd.id && td.discountApplied.id)
                      return td.discountApplied.id === acd.id;
                  });
                  return !_applied;
                });
            }
          }
        }
      });
  }

  getApplicableDiscountsForPlayer() {
    this.playerProfiles = [];
    this.playerActiveClubDiscount = [];
    let _clubId = this.clubInfo ? this.clubInfo.id : null;
    if (!_clubId) return false;
    if (!this.player) return false;
    let _playerId = this.player.id || this.player.playerId;
    let _playerType = this.bookingPlayer.playerType;
    let _bookingPlayerId = this.bookingPlayer.id;
    let _effectiveDate = moment(
      this.currentSlot.slotAssigned.teeOffDate
    ).format('YYYY-MM-DD');
    this.flightService
      .getApplicableDiscountsForPlayer(_clubId, _playerId, _effectiveDate)
      .subscribe((activeClubDiscounts: Array<TeeTimeDiscount>) => {
        if (activeClubDiscounts && activeClubDiscounts.length > 0) {
          this.activeClubDiscounts = activeClubDiscounts;
          this.playerActiveClubDiscount = activeClubDiscounts.filter((pacd) => {
            let _hasApplied = this.appliedBookingDiscounts.filter((abd) => {
              if (abd && abd.discountApplied) {
                return (
                  abd.discountApplied.id === pacd.id &&
                  abd.bookingPlayerId === _bookingPlayerId
                );
              } else return false;
            });
            if (!_hasApplied || _hasApplied.length === 0) return true;
            else if (_hasApplied && !pacd.discountProgram) return true;
            else if (_hasApplied && pacd.discountProgram) return false;
            else return false;
          });
        }
      });
  }

  getPlayerProfile(profile: string) {
    return PlayerTypes[profile];
  }

  getDiscountText(discount: TeeTimeDiscount, type?: string) {
    if (!discount) return false;
    if (
      this.playerActiveClubDiscount &&
      this.playerActiveClubDiscount.length === 0
    )
      return false;
    if (!this.playerActiveClubDiscount) return false;
    let _currency;
    let _discountDetails = this.getDiscountDetails(discount);
    if (!_discountDetails) return false;
    _currency = discount.club.address.countryData.currencySymbol;
    switch (type) {
      case 'amount':
        if (discount.amountType.toLowerCase() === 'percentage')
          return discount.discount + '% off';
        else if (discount.amountType.toLowerCase() === 'absolute')
          return 'Save ' + _currency + ' ' + discount.discount;
        else if (discount.amountType.toLowerCase() === 'fixed' || discount.amountType.toLowerCase() === 'package')
          return 'Up to ' + _currency + ' ' + discount.discount;
      case 'appliesFor':
        let _appliesFor = 'Covers ';
        let _buggyFee = _discountDetails.priceComponents.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'buggyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hbuggyfee')
            return true;
          else return false;
        });

        let _caddyFee = _discountDetails.priceComponents.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'caddyfee') return true;
          if (price.priceComponent.id.toLowerCase() === 'hcaddyfee')
            return true;
          else return false;
        });
        _discountDetails.priceComponents =
          _discountDetails.priceComponents.filter((price) => {
            if (_buggyFee.length === 2)
              return price.priceComponent.id.toLowerCase() !== 'hbuggyfee';
            if (_caddyFee.length === 2)
              return price.priceComponent.id.toLowerCase() !== 'hcaddyfee';
            else return true;
          });
        if (
          !_discountDetails.priceComponents ||
          _discountDetails.priceComponents.length === 0
        )
          return '';
        if (_discountDetails && _discountDetails.priceComponents)
          _appliesFor += _discountDetails.priceComponents
            .map((a) => {
              return a.priceComponent.name;
            })
            .reduce((a, b) => {
              return a + ', ' + b;
            });
        return _appliesFor;
      case 'appliesTo':
        let _appliesTo = 'Applies to ';
        if (
          !_discountDetails.playerTypes ||
          _discountDetails.playerTypes.length === 0
        )
          return '';
        _appliesTo += _discountDetails.playerTypes
          .map((a) => {
            return a.bookingPlayerType.name;
          })
          .reduce((a, b) => {
            return a + ', ' + b;
          });
        return _appliesTo;
    }
  }

  getDiscountDetails(discount: TeeTimeDiscount) {
    if (!discount) return false;
    let _discountDetails;
    if (this.playerActiveClubDiscount)
      _discountDetails = this.playerActiveClubDiscount
        .filter((td) => {
          return td.id === discount.id;
        })
        .map((td) => {
          return td;
        });
    if (_discountDetails && _discountDetails.length > 0)
      return _discountDetails[0];
    else return null;
  }

  checkVoucherUnusable() {
    let _playerId = this.bookingPlayer.player.id;
    if (
      !this.bookingDiscounts ||
      (this.bookingDiscounts && this.bookingDiscounts.length === 0)
    )
      return false;
    let _hasVoucherUnusable = this.bookingDiscounts.filter((bd) => {
      if (
        bd.voucherApplied &&
        !bd.voucherApplied.usableWithOtherRewards &&
        !bd.voucherApplied.appliesToFlight &&
        bd.voucherApplied.playerAssigned.id === _playerId
      )
        return true;
      else if (
        bd.voucherApplied &&
        !bd.voucherApplied.usableWithOtherRewards &&
        bd.voucherApplied.appliesToFlight
      )
        return true;
    });
    if (_hasVoucherUnusable && _hasVoucherUnusable.length > 0) return true;
    else return false;
  }

  checkOtherVouchers() {
    let _playerId = this.bookingPlayer.player.id;
    if (
      !this.bookingDiscounts ||
      (this.bookingDiscounts && this.bookingDiscounts.length === 0)
    )
      return false;
    let _hasOtherVoucher = this.bookingDiscounts.filter((bd) => {
      if (bd.voucherApplied && bd.voucherApplied.appliesToFlight) return true;
      if (
        bd.voucherApplied &&
        bd.voucherApplied.playerAssigned.id === _playerId
      )
        return true;
    });
    if (_hasOtherVoucher && _hasOtherVoucher.length > 0) return true;
    else return false;
  }

  removeOtherVouchers(vs: TeeTimeClubVoucherSeries) {
    let _playerId = this.bookingPlayer.player.id;
    let _bookingPlayerId = this.bookingPlayer.id;
    if (
      !this.bookingDiscounts ||
      (this.bookingDiscounts && this.bookingDiscounts.length === 0)
    )
      return false;
    this.bookingDiscounts.filter((bd, idx) => {
      if (bd.voucherApplied && bd.voucherApplied.appliesToFlight) {
        this.goRemoveThisVoucher(bd.voucherApplied, vs);
      } else if (
        bd.voucherApplied &&
        !bd.voucherApplied.appliesToFlight &&
        vs.appliesToFlight
      ) {
        this.goRemoveThisVoucher(bd.voucherApplied, vs);
      } else if (
        bd.voucherApplied &&
        bd.voucherApplied.playerAssigned.id === _playerId
      ) {
        this.goRemoveThisVoucher(bd.voucherApplied, vs);
      }
      let _discountApplied;
      if (bd.discountApplied) {
        if (bd.discountAudit)
          bd.discountAudit.discountsByPlayer.filter((dbp) => {
            if (dbp.playerId === _playerId) {
              this.onRemoveThisDiscount(bd.discountApplied);
            }
          });
        else if (!bd.discountAudit) {
          if (_bookingPlayerId === bd.bookingPlayerId)
            this.onRemoveThisDiscount(bd.discountApplied);
        }
      }
      if (idx === this.bookingDiscounts.length - 1) {
        setTimeout(() => {
          if (vs) this.goUseThisVoucherSeries(vs);
        }, 500);
      }
    });
  }

  async onUseThisDiscount(discount: TeeTimeDiscount) {
    if (this.checkVoucherUnusable()) {
      let prompt = await this.alertCtrl.create({
        header: 'Use Discount',
        message:
          'There is exclusive voucher applied in this flight. Please remove the voucher before applying discount.',
        buttons: [
          {
            text: 'Close',
            handler: (data) => {
              prompt.dismiss();
            },
          },
        ],
      });
      prompt.present();
    } else {
      let prompt = await this.alertCtrl.create({
        header: 'Use Discount',
        message:
          'This will apply discount to current booking flight. Do you want to proceed?',
        buttons: [
          {
            text: 'No',
            handler: (data) => {
              prompt.dismiss();
              return false;
            },
          },
          {
            text: 'Yes',
            handler: () => {
              this.goUseThisDiscount(discount);
              prompt.dismiss();
              return false;
            },
          },
        ],
      });
      prompt.present();
    }
  }

  goUseThisDiscount(discount: TeeTimeDiscount) {
    let _bookingPlayerId = this.bookingPlayer.id;
    let _discountUsed: boolean = false;
    if (this.discountUsed && this.discountUsed.length > 0) _discountUsed = true;
    let _discount = discount;
    let _force: boolean = false;
    this.flightService
      .applyPlayerBookingDiscount(
        this.bookingId,
        _discount.id,
        _bookingPlayerId,
        _force
      )
      .subscribe((data: any) => {
        if (data) {
          let _data = data.json();
          MessageDisplayUtil.showMessageToast(
            'Successfully applied discount',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          this.isVoucherApplied = true;
          this.appliedBookingDiscounts = _data.bookingDiscounts;
          if (this.appliedBookingDiscounts) {
            this.getApplicableDiscountsForPlayer();
          }
        }
      }),
      (error) => {
        let _error = error.json();
        MessageDisplayUtil.showErrorToast(
          _error.errors[0],
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
        return false;
      },
      () => {
        if (this.forBooking) this.getBookingFlight();
      };
  }

  onRemoveThisDiscount(discount: TeeTimeDiscount) {
    if (!discount) {
      MessageDisplayUtil.showMessageToast(
        'Successfully removed discount',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
    let _bookingPlayerId;
    if (this.fromClub) _bookingPlayerId = this.bookingPlayer.id;
    this.flightService
      .removePlayerBookingDiscount(
        this.bookingId,
        discount.id,
        _bookingPlayerId
      )
      .subscribe((data: any) => {
        if (data) {
          let _data = data.json();
          this.isVoucherApplied = true;
          this.appliedBookingDiscounts = _data.bookingDiscounts;
          if (this.appliedBookingDiscounts) {
            this.getApplicableDiscountsForPlayer();
          }
        }
      });
  }

  async onApplyThisProfile(profile: PlayerTypes) {
    let prompt = await this.alertCtrl.create({
      header: 'Apply Profile',
      message:
        'This will apply selected profile to current player. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.goApplyProfile(profile);
            prompt.dismiss();
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goApplyProfile(profile: PlayerTypes) {
    if (!profile) return false;
    let _bookingId = this.bookingId;
    let _bookingPlayer = this.bookingPlayer;
    _bookingPlayer['playerTypeUsed.id'] = profile;
    this.flightService
      .updateBookingPlayerDetails(this.bookingId, _bookingPlayer, 'playerType')
      .subscribe((data) => {
        if (data) {
          let _data = data.json();
          this.isVoucherApplied = true;
          this.close();
        }
      });
  }

  async onResetProfileClick() {
    let prompt = await this.alertCtrl.create({
      header: 'Reset Profile',
      message:
        'This will reset current player profile to original. Do you want to proceed?',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.goResetProfile();
            prompt.dismiss();
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goResetProfile() {
    let _bookingId = this.bookingId;
    let _bookingPlayer = this.bookingPlayer;
    _bookingPlayer['playerTypeUsed.id'] = '';
    this.flightService
      .updateBookingPlayerDetails(
        this.bookingId,
        _bookingPlayer,
        'resetProfile'
      )
      .subscribe((data) => {
        if (data) {
          let _data = data.json();
          this.isVoucherApplied = true;
          this.close();
        }
      });
  }

  getVoucherAmount(voucherSeries: TeeTimeClubVoucherSeries, type: string) {
    let _totalVouchers;
    let _voucherCount;
    if (
      !this.voucherSeries ||
      (this.voucherSeries && this.voucherSeries.length === 0)
    )
      return;
    if (
      !this.playerVoucher ||
      (this.playerVoucher && this.playerVoucher.length === 0)
    )
      return;
    switch (type) {
      case 'all':
        _voucherCount = this.voucherSeries.filter((vs) => {
          let _hasVoucher;
          this.playerVoucher.filter((pv) => {
            if (pv.seriesId === vs.id) _hasVoucher = true;
            else _hasVoucher = false;
          });
          return _hasVoucher;
        });
        return _voucherCount ? _voucherCount.length : 0;
      case 'voucher':
        _voucherCount = this.playerVoucher.filter((playerVoucher) => {
          let _hasApplied = false;
          if (this.appliedVouchers && this.appliedVouchers.length > 0) {
            this.appliedVouchers.filter((av) => {
              if (av.seriesId === playerVoucher.seriesId) _hasApplied = true;
              else _hasApplied = false;
            });
          }
          return playerVoucher.seriesId === voucherSeries.id && !_hasApplied;
        });
        return _voucherCount ? _voucherCount.length : 0;
    }

  }

  async onImageClick(imageUrl: string) {
    let image = await this.modalCtrl.create({
      component: ImageZoomPage,
cssClass: 'self-adjustable-modal',
      componentProps: {
        image: imageUrl,
      },
    });

    image.present();
  }

  async onUseThisVoucherSeries(voucherSeries: TeeTimeClubVoucherSeries) {
    if (this.checkVoucherUnusable()) {
      let prompt = await this.alertCtrl.create({
        header: 'Use Voucher',
        message:
          'There is exclusive voucher applied in this flight. Please remove the voucher first before applying voucher.',
        buttons: [
          {
            text: 'Close',
          },
        ],
      });
      prompt.present();
      return false;
    }
    let _message;
    let _needRemoveVoucher: boolean = false;
    if (voucherSeries.appliesToFlight && voucherSeries.usableWithOtherRewards)
      _message =
        'This will apply voucher to whole flight. Do you want to proceed?';
    else if (
      !voucherSeries.appliesToFlight &&
      voucherSeries.usableWithOtherRewards
    )
      _message =
        'This will apply voucher to current booking. Do you want to proceed?';
    else if (
      !voucherSeries.usableWithOtherRewards &&
      !voucherSeries.appliesToFlight
    ) {
      _message =
        'This voucher is not usable with other promotions. If you use this it will clear all other deals. Do you want to proceed?';
      if (this.checkOtherVouchers()) _needRemoveVoucher = true;
    } else if (
      voucherSeries.appliesToFlight &&
      !voucherSeries.usableWithOtherRewards
    ) {
      if (this.checkOtherVouchers()) _needRemoveVoucher = true;
      _message =
        'This voucher is applicable to the whole flight and is not usable with other promotions. If you use this it will clear all other deals. Do you want to proceed? ';
    }
    let prompt = await this.alertCtrl.create({
      header: 'Use Voucher',
      message: _message,
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            if (_needRemoveVoucher) this.removeOtherVouchers(voucherSeries);
            else this.goUseThisVoucherSeries(voucherSeries);
            prompt.dismiss();
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goUseThisVoucherSeries(voucherSeries: TeeTimeClubVoucherSeries) {
    let _useVoucher;
    _useVoucher = this.playerVoucher
      .filter((pv) => {
        return pv.seriesId === voucherSeries.id;
      })
      .sort((a, b) => {
        if (a.id < b.id) return 1;
        else if (b.id < a.id) return -1;
        else return 0;
      });

    if (_useVoucher && _useVoucher.length > 0)
      this.goUseThisVoucher(_useVoucher[0]);
    else {
      MessageDisplayUtil.showMessageToast(
        'Please try again',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }
  }

  async getPlayerDiscountPrograms(loader?) {
    let _loader;
    if (!loader) {
      _loader = await this.loadingCtl.create({
        message: 'Getting Discounts...',
        showBackdrop: false,
        duration: 5000,
      });
    } else {
      _loader = loader;
    }
    let _playerId;
    if (this.player)
      _playerId = this.player.playerId ? this.player.playerId : this.player.id;
    _loader.present().then(() => {
      this.flightService
        .getPlayerDiscountPrograms(_playerId)
        .subscribe((data: any) => {
          if (data) {
            let _isAgent;
            if(this.fromPartner && this.fromPartner.partnerServices && this.fromPartner.partnerServices.length > 0)
                _isAgent = this.fromPartner.partnerServices.filter((s)=>{
                    return s.toLowerCase().includes('agent');
                })
            data = data.filter((program: PlayerDiscountProgram)=>{
                if(this.type === 'handicap')
                    return program.discountProgram.includesHandicap
                else if(this.type === 'discount' && this.fromPartner) {
                    if(_isAgent) return program.discountProgram.includesDiscount;
                    else return program.discountProgram.discountCompany && program.discountProgram.discountCompany.id === this.fromPartner.id
                }
                else
                    return program.discountProgram.includesDiscount; // && !program.discountProgram.includesHandicap

            })
            if(this.type === 'handicap') {
              this.playerDiscountPrograms = data.sort((a,b) => {
                  // let _dateA = moment(a.applicationRenewed.applicationDate, 'YYYY-MM-DD').toDate();
                  // let _dateB = moment(b.applicationRenewed.applicationDate, 'YYYY-MM-DD').toDate();
                  let _dateA = moment(a.validUntil, 'YYYY-MM-DD').toDate();
                  let _dateB = moment(b.validUntil, 'YYYY-MM-DD').toDate();
                  if(_dateA > _dateB) return -1
                  else if(_dateA < _dateB) return 1
                  else return 0;
              });

          } else {
            this.playerDiscountPrograms = data.sort((a, b) => {
              if (a.validUntil > b.validUntil) return -1;
              else if (b.validUntil < a.validUntil) return 1;
              else {
                if(a.discountProgram.discountCompany.name < b.discountProgram.discountCompany.name) return -1;
                else if(a.discountProgram.discountCompany.name > b.discountProgram.discountCompany.name) return 1;
                else return 0;
              }
              // if (
              //   a.discountProgram.discountCompany.name <
              //   b.discountProgram.discountCompany.name
              // ) {
              //   if (a.validUntil < b.validUntil) return 1;
              //   else if (b.validUntil < a.validUntil) return -1;
              //   else return -1;
              // } else if (
              //   a.discountProgram.discountCompany.name >
              //   b.discountProgram.discountCompany.name
              // ) {
              //   if (a.validUntil < b.validUntil) return 1;
              //   else if (b.validUntil < a.validUntil) return -1;
              //   else return 1;
              // } else return 0;
            });

            this.playerDiscountPrograms.forEach((pdp) => {
              // JsonService.deriveFulImageURL(pdp, 'document');
            });
          }

          }
        }),
        (error) => {

          if (_loader) _loader.dismiss();
        },
        () => {
          if (_loader) _loader.dismiss();
        };
    });
  }

  getProgramDetails(program: PlayerDiscountProgram, type?: string) {
    let _discountProgram = program.discountProgram;
    let _discountCompany = _discountProgram.discountCompany;
    switch (type) {
      case 'name':
        return _discountProgram.name;
      case 'membershipNo':
        return program.membershipNumber;
      case 'description':
        return _discountProgram.description;
      case 'company':
        return _discountCompany.name;
      case 'verifiedByCompany':
        return program.verifiedByCompany;
      case 'verifiedOn':
        return moment(program.verifiedOn, 'YYYY-MM-DD').format('ddd, DD MMM YYYY');
    }
  }

  goRemoveDiscount(program: PlayerDiscountProgram) {
    let _playerDiscountId;
    if (program) _playerDiscountId = program.id;
    this.flightService
      .deletePlayerDiscountCard(_playerDiscountId)
      .subscribe((data) => {
        if (data) {
          MessageDisplayUtil.showMessageToast(
            'Successfully removed player discount card',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          this.getPlayerDiscountPrograms();
          return false;
        }
      }),
      (error) => {
        let _error = error.json();
        let _msg;
        _msg =
          'Card is already approved in one of the club application. Please remove from the applied club.';
        MessageDisplayUtil.showMessageToast(
          _msg,
          this.platform,
          this.toastCtl,
          7000,
          'bottom'
        );
        this.getPlayerDiscountPrograms();
        return false;
      },
      () => {
        if (this.forBooking) this.getBookingFlight();
      };
  }
  onPrivilegeCardApprove(pdp?: PlayerDiscountProgram) {
    let _playerId = pdp.player.playerId ? pdp.player.playerId : pdp.player.id;
    let _programId = pdp.discountProgram.id;
    let _playerDiscountProgramId: Array<number> = [];
    _playerDiscountProgramId.push(pdp.id);
    let _clubId = this.clubId ? this.clubId : this.clubInfo.id;
    this.flightService
      .approvePlayerDiscountCard(_playerId, _playerDiscountProgramId, _clubId)
      .subscribe(
        (data) => {
          if (data) {
            this.setOptionType(2);
          }
        },
        (error) => {
          let _error = error.json();
          if (_error && _error.status === 409) {
            this.flightService
              .applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
              .subscribe(
                (data) => {
                  let _data = data.json();

                  if (_data && _data.length > 0) {
                    let _pdp = _data
                      .filter((pdp) => {
                        return pdp.club.id === _clubId;
                      })
                      .map((pdp) => {
                        return pdp;
                      });
                    this.onPrivilegeCardApprove(pdp);
                  }
                },
                (error) => {
                  let _error = error.json();
                  if (_error && _error.status !== 200) {
                    let _msg = _error.errors[0];
                    MessageDisplayUtil.showMessageToast(
                      _msg,
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                    return false;
                  }
                }
              );
          }
        },
        () => {
          this.setOptionType(2);
        }
      );
  }

  async onPrivilegeApplyClub(pdp: PlayerDiscountProgram) {
    let prompt = await this.alertCtrl.create({
      header: 'Apply Discount Program',
      message:
        'This will apply discount program to this club. Do you want to proceed? ',
      buttons: [
        {
          text: 'No',
          handler: (data) => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            prompt.dismiss().then(() => {
              this.goApplyPrivilegeClub(pdp);
            });
            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  goApplyPrivilegeClub(pdp: PlayerDiscountProgram) {
    let _playerId = pdp.player.playerId ? pdp.player.playerId : pdp.player.id;
    let _programId = pdp.discountProgram.id;
    let _clubId = this.currentSlot.clubData.id;
    this.flightService
      .applyForClubVerifyDiscountCard(_playerId, _programId, _clubId)
      .subscribe(
        (data) => {
          if (data) {
            this.setOptionType(2);
          }
        },
        (error) => {
          let _error = error.json();
          if (_error && _error.status !== 200) {
            let _msg = _error.errors[0];
            if (_error.errorCode.includes('DiscountProgramNotRecognized'))
              _msg = 'There is no valid club discount associated to this card';
            MessageDisplayUtil.showMessageToast(
              _msg,
              this.platform,
              this.toastCtl,
              3000,
              'bottom'
            );
            return false;
          }
        }
      );
  }

  getPlayerDiscountCardApplications(
    playerId: number,
    programId: string
  ): DiscountPlayerClub {

    let _playerId = playerId;
    let _programId = programId;
    let _allPdp;
    let _clubId = this.clubId ? this.clubId : this.clubInfo.id;
    this.flightService
      .getListAllCardApplyForPlayer(_playerId, _programId)
      .subscribe((data) => {
        let _data: Array<DiscountPlayerClub>;
        _data = data.json();
        if (_data && _data.length > 0) {
          _allPdp = _data
            .filter((dpc: DiscountPlayerClub) => {
              if (dpc.club && dpc.club.id === _clubId && dpc.approved)
                return true;
            })
            .map((dpc) => {
              return dpc;
            });
        }
      });
    return _allPdp;
  }

  getPendingPlayerDiscountCard(status?: string) {
    if (this.bookingPlayer && !this.bookingPlayer.player) return;
    let _pendingPDP = [];
    let _approvedPDP = [];
    let _pendingDiscountCards = [];
    this.pendingPDP = [];
    let _playerId = this.bookingPlayer.player.playerId
      ? this.bookingPlayer.player.playerId
      : this.bookingPlayer.player.id;
    let _clubId = this.clubId ? this.clubId : this.clubInfo.id;
    this.flightService.getListAllPlayersCardDiscount(_clubId).subscribe(
      (data) => {
        let _pdp: Array<DiscountPlayerClub>;
        if (data) _pdp = data;
        if (_pdp && _pdp.length > 0) {
          _pdp.filter((p: DiscountPlayerClub) => {
            if (
              p.club.id === _clubId &&
              !p.approved &&
              p.playerDiscountProgram.player.id === _playerId
            ) {
              _pendingDiscountCards.push(p.playerDiscountProgram);
              this.pendingPDP.push(p.playerDiscountProgram);
              if (status === 'pending')
                _pendingPDP.push(p.playerDiscountProgram);
            } else if (
              p.club.id === _clubId &&
              p.approved &&
              p.playerDiscountProgram.player.id === _playerId
            ) {
              if (status === 'approved')
                _approvedPDP.push(p.playerDiscountProgram);
            }
          });

          if (status === 'approved')
            this.playerApprovedDP.push(..._approvedPDP);
          else if (status === 'pending')
            this.playerPendingDP.push(..._pendingPDP);
        }
      },
      (error) => { },
      () => {
        if (status === 'approved') this.playerApprovedDP.push(..._approvedPDP);
        else if (status === 'pending')
          this.playerPendingDP.push(..._pendingPDP);
      }
    );
  }

  getDealsAmount(
    amount: any,
    amountType: string,
    currency?: any,
    item?: any,
    type?: string,
    applied: boolean = false
  ) {
    if (!amount && type !== 'privilege') return '';
    let _currency; // = currency?currency.symbol:this.currency?this.currency.symbol:this.bookingSlot.clubData.address.countryData.currencySymbol;
    if (type === 'privilege' && applied) {
      let _clubId = this.clubInfo ? this.clubInfo.id : null;
      if (!_clubId) return false;
      if (!this.player) return false;
      let _playerId = this.player.id || this.player.playerId;
      let _effectiveDate = moment(
        this.currentSlot.slotAssigned.teeOffDate
      ).format('YYYY-MM-DD');
      this.applicableClubDiscount
        .filter((pac) => {
          return (pac.id = item.id);
        })
        .map((pac) => {
          item = pac;
        });
    }
    if (this.currentSlot) {
      _currency = this.currentSlot.clubData.address.countryData.currencySymbol;
    } else if (!this.currentSlot && item && item.club) {
      _currency = item.club.address.countryData.currencySymbol;
    }
    let _amount = amount;
    let _amountType = amountType;

    let _flightApply;
    let _bookingApply;
    let _amPMtype;
    if (type === 'privilege' && item.applicableRate) {
      if (this.forBooking) {
        _amPMtype = moment(
          this.currentSlot.slotAssigned.teeOffTime,
          'HH:mm:ss'
        ).format('a');
      }
      if (_amPMtype === 'am') {
        _amount = item.applicableRate.amRate;
        _amountType = item.applicableRate.amRateType;
      } else if (_amPMtype === 'pm') {
        _amount = item.applicableRate.pmRate;
        _amountType = item.applicableRate.pmRateType;
      }
    }

    if (type === 'privilege') {
      _bookingApply = item.appliesToBooking;
    } else {
      _flightApply = item.appliesToFlight;
      _bookingApply = item.appliesToBookingAmount;
    }

    let _amountText;
    let _flightTxt;
    let _maxFlightSize = item && item.maxFlightSize ? item.maxFlightSize : 4;
    if (type === 'voucher') {
      if (_flightApply) _flightTxt = 'for flight of ' + _maxFlightSize;
      else _flightTxt = 'for 1 person';
    } else if (type === 'privilege') {
      if (_bookingApply) _flightTxt = 'for booking amount';
      else _flightTxt = 'for covered items';
    }

    if (_amountType === 'Absolute') {
      _amountText = 'Save ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Fixed' || _amountType === 'Package') {
      _amountText = 'Pay up to ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Percentage') {
      _amountText = _amount + '% off';
    }
    if (type === 'voucher') return _amountText + ' ' + _flightTxt;
    else if (type === 'privilege') return _amountText + ' ' + _flightTxt;
    else return _amountText;
  }

  getAppliedDiscounts(type?: string) {
    let _discounts = [];
    let _approvedPDP = [];
    _approvedPDP = this.playerApprovedDP; //this.getPendingPlayerDiscountCard('approved');
    let _pendingPDP = [];
    let _playerId = null;
    let _bookingPlayerId = null;
    if (this.bookingPlayer && this.bookingPlayer.player)
      _playerId = this.bookingPlayer.player.id;
    if (this.bookingPlayer) _bookingPlayerId = this.bookingPlayer.id;
    _pendingPDP = this.playerPendingDP; //this.getPendingPlayerDiscountCard('pending');
    if (
      !this.appliedBookingDiscounts ||
      this.appliedBookingDiscounts.length === 0
    )
      return _discounts;
    if (
      this.currentSlot.slotAssigned &&
      this.currentSlot.slotAssigned.pricingPlanPromotional &&
      !this.currentSlot.slotAssigned.pricingPlanPromotional.discountsApplicable
    )
      return _discounts;
    switch (type) {
      case 'clubDiscount':
        _discounts = this.appliedBookingDiscounts.filter((bd) => {
          if (bd.discountApplied) {
            if (this.fromClub) {
              return (
                (bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                (!bd.discountApplied.discountProgram &&
                  bd.discountApplied.amountType === 'Package')
              );
            } else {
              return (
                (!bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                (!bd.discountApplied.discountProgram &&
                  bd.discountApplied.amountType === 'Package' &&
                  !bd.discountApplied.availableForClubOnly)
              );
            }
          }
        });
        _discounts = _discounts.filter((bd: TeeTimeBookingDiscount) => {
          let _isPlayerDiscount = false;
          if(_bookingPlayerId === bd.bookingPlayerId) _isPlayerDiscount = true
          // if (bd.discountAudit)
          //   bd.discountAudit.discountsByPlayer.filter((p) => {
          //     if (p.playerId === _playerId) _isPlayerDiscount = true;
          //     else _isPlayerDiscount = false;
          //   });
          // else if (!bd.discountAudit) {
          //   if (_bookingPlayerId === bd.bookingPlayerId)
          //     _isPlayerDiscount = true;
          // }
          return _isPlayerDiscount;
        });
        break;
      case 'privilege':
        _discounts = this.appliedBookingDiscounts.filter((bd) => {
          if (bd.discountApplied && bd.discountApplied.discountProgram) {
            if (this.fromClub) {
              return (
                (bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                (bd.discountApplied.discountProgram &&
                  bd.discountApplied.amountType === 'Package' &&
                  bd.bookingPlayerId &&
                  bd.bookingPlayerId === _bookingPlayerId)
              );
            } else {
              return (
                ((bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                  (bd.discountApplied.discountProgram &&
                    bd.discountApplied.amountType === 'Package')) &&
                bd.bookingPlayerId &&
                bd.bookingPlayerId === _bookingPlayerId
              );
            }
          }
        });

        // if (_approvedPDP && _approvedPDP.length > 0) {
        //   _discounts = _discounts.filter((bd) => {
        //     let _hasPDP = _approvedPDP.filter((pdp: PlayerDiscountProgram) => {
        //       if (pdp.discountProgram && bd.discountApplied.discountProgram)
        //         return (
        //           pdp.discountProgram.id ===
        //           bd.discountApplied.discountProgram.id
        //         );
        //     });
        //     return _hasPDP && _hasPDP.length > 0;
        //   });
        // } else if (_approvedPDP && _approvedPDP.length === 0) {
        //   _discounts = [];
        // }
        // break;
    }
    _discounts.forEach((bd: TeeTimeBookingDiscount) => {
      let _priceComponents = this.activeClubDiscounts
        .filter((d) => {
          if (d.id === bd.discountApplied.id) {
            return true;
          }
        })
        .map((d) => {
          return d.priceComponents;
        });
      if (bd && bd.discountApplied && bd.discountApplied.priceComponents)
        bd.discountApplied.priceComponents = _priceComponents;
    });
    return _discounts;
  }

  getAvailableDiscounts(type?: string) {
    let _appliedDiscounts = [];
    let _discounts = [];
    let _approvedPDP = [];
    _approvedPDP = this.playerApprovedDP; //this.getPendingPlayerDiscountCard('approved');
    let _pendingPDP = [];
    _pendingPDP = this.playerPendingDP; //this.getPendingPlayerDiscountCard('pending');
    let _player: TeeTimeBookingPlayer;
    _player = this.bookingPlayer;

    if (
      !this.playerActiveClubDiscount ||
      this.playerActiveClubDiscount.length === 0
    )
      return _discounts;
    if (
      this.currentSlot.slotAssigned &&
      this.currentSlot.slotAssigned.pricingPlanPromotional &&
      !this.currentSlot.slotAssigned.pricingPlanPromotional.discountsApplicable
    )
      return _discounts;
    switch (type) {
      case 'clubDiscount':
        _discounts = this.playerActiveClubDiscount.filter((bd) => {
          if (this.fromClub) return !bd.discountProgram;
          else return !bd.discountProgram && !bd.availableForClubOnly;
        });

        _appliedDiscounts = this.appliedBookingDiscounts.filter((bd) => {
          if (bd.discountApplied && bd.discountAudit) {
            let _isPlayer = false;
            if (bd.discountAudit)
              bd.discountAudit.discountsByPlayer.filter((dp) => {
                if (dp.playerId === _player.player.id) _isPlayer = true;
                else _isPlayer = false;
              });
            else if (!bd.discountAudit) {
              if (_player.id === bd.bookingPlayerId) _isPlayer = true;
            }
            if (this.fromClub) {
              return (
                (!bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                (!bd.discountApplied.discountProgram &&
                  bd.discountApplied.amountType === 'Package' &&
                  _isPlayer)
              );
            } else {
              return (
                ((!bd.discountApplied.discountProgram &&
                  bd.amountDeducted > 0 &&
                  bd.discountApplied.amountType !== 'Package') ||
                  (!bd.discountApplied.discountProgram &&
                    bd.discountApplied.amountType === 'Package')) &&
                !bd.discountApplied.availableForClubOnly &&
                _isPlayer
              );
            }
          } else return false;
        });
        _discounts = _discounts.filter((bd: TeeTimeDiscount) => {
          if (0) {
            let _goodPlayerType = bd.playerTypes.filter((pt) => {
              if (_player.playerTypeUsed)
                return pt.bookingPlayerType.id === _player.playerTypeUsed.id;
              else if (_player.playerType && !_player.playerTypeUsed)
                return pt.bookingPlayerType.id === _player.playerType.id;
              else return false;
            });
          }

          let _isApplied;
          _appliedDiscounts.filter((ad) => {
            if (ad.discountApplied.id === bd.id) _isApplied = true;
          });
          return !_isApplied;
        });
        break;
      case 'privilege':
        _discounts = this.playerActiveClubDiscount.filter((bd) => {
          if (this.fromClub) return bd.discountProgram;
          else return bd.discountProgram && !bd.availableForClubOnly;
        });
        if (0) {
          _discounts = _discounts.filter((bd) => {
            let _goodPlayerType = bd.playerTypes.filter((pt) => {
              if (_player.playerTypeUsed)
                return pt.bookingPlayerType.id === _player.playerTypeUsed.id;
              else if (_player.playerType && !_player.playerTypeUsed)
                return pt.bookingPlayerType.id === _player.playerType.id;
              else return false;
            });
            if (_goodPlayerType && _goodPlayerType.length > 0) return true;
            else return false;
          });
        }
        if (_approvedPDP && _approvedPDP.length > 0) {
          _discounts = _discounts.filter((bd) => {
            let _hasPDP = _approvedPDP.filter((pdp: PlayerDiscountProgram) => {
              if (pdp.discountProgram && bd.discountProgram)
                return pdp.discountProgram.id === bd.discountProgram.id;
            });
            return _hasPDP && _hasPDP.length > 0;
          });
        } else if (_approvedPDP && _approvedPDP.length === 0) {
          _discounts = [];
        }
        break;
    }
    return _discounts;
  }

  async onZoomImage(image: string) {
    let imageZoom = await this.modalCtrl.create({
      component: ImageZoomPage,
cssClass: 'self-adjustable-modal',
      componentProps: {
        image: image,
      },
    });

    imageZoom.onDidDismiss().then((data: any) => { });
    imageZoom.present();
  }

  async onUploadCardClick(pdp: PlayerDiscountProgram) {
    let _buttons = [];
    _buttons.push({
      text: 'Select Photo',
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        this.onUploadPlayerCard(pdp);
      },
    });
    _buttons.push({
      text: 'Take Photo',
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        this.onTakePhotoPlayerCard(pdp);
      },
    });

    let actionSheet = await this.actionSheetCtl.create({
      buttons: _buttons,
    });
    actionSheet.present();
  }
  onTakePhotoPlayerCard(pdp: PlayerDiscountProgram) {
    this.imageService.captureImage(true).then((data: any) => {
      this._uploadImage(data.dataUrl, pdp);
    });
  }

  onUploadPlayerCard(pdp: PlayerDiscountProgram) {
    this.imageService.pickImage().then((data: any) => {
      this._uploadImage(data, pdp);
    });
  }
  async _uploadImage(imageURL: string, pdp: PlayerDiscountProgram) {
    let _playerDiscountCardId = pdp.id;
    let uploadLoading = await this.loadingCtl.create({
      message: 'Uploading, Please wait...',
    });
    if (1) {
      // !this.isCordova()
      uploadLoading.present().then(() => {
        // this.imageData
        this.flightService
          .uploadPlayerCardDiscountWeb(
            this.selectedFiles,
            imageURL,
            _playerDiscountCardId
          )
          .subscribe(
            (data) => {
              uploadLoading.dismiss().then(() => {
                // if(data) this.playerDiscountProgram = data;
                if (data) this.temporaryImageURL = imageURL;
                // this.cancelEditImage();
              });
            },
            (error) => {

              uploadLoading.dismiss().then(async () => {
                // let _error = error.error;
                // if(error.json()) _error = error.json();
                // else _error = error.error;
                let _msg = 'Please upload photo not more than 10 MB';
                // if(_error && _error.errorMessage) _msg = _error.errorMessage;
                // 'Please upload photo not more than 10 MB'
                // if(error || error !== null) {
                let alert = await this.alertCtrl.create({
                  header: 'Upload Error',
                  message: _msg,
                  buttons: ['Ok'],
                });
                alert.present();
                // }
                // else this.cancelEditImage();
              });
            },
            () => {
              this.setOptionType(2);
              // this.modalCtrl.dismiss({
              //   created: true,
              // });
            }
          );
      });
    } else {
      uploadLoading.present().then(() => {
        this.playerHomeActions
          .uploadPlayerCardDiscount(
            imageURL,
            ContentType.JPEG,
            _playerDiscountCardId
          )
          .subscribe(
            (data) => {
              uploadLoading.dismiss().then(() => {
                this.getPlayerDiscountPrograms();
                // this.cancelEditImage();
              });
            },
            (error) => {
              //
              uploadLoading.dismiss().then(async () => {
                // 'Please upload photo not more than 10 MB'
                // if(error || error !== null) {
                let alert = await this.alertCtrl.create({
                  header: 'Upload Error',
                  message: 'Please upload photo not more than 10 MB',
                  buttons: ['Ok'],
                });
                alert.present();
                // }
                // else this.cancelEditImage();
              });
            }
          );
      });
    }
  }
  isCordova() {
    return this.platform.is('capacitor');
  }
  getBookingFlight() {
    let _bookingId = this.currentSlot.id;
    this.flightService
      .getBookingById(_bookingId)
      .subscribe((bookingByPlayer: TeeTimeBooking) => {
        if (bookingByPlayer) {
          this.currentSlot = bookingByPlayer;
          if (this.currentSlot.bookingDiscounts) {
            this.appliedBookingDiscounts = this.currentSlot.bookingDiscounts;
            this.bookingDiscounts = this.currentSlot.bookingDiscounts;
            if (this.appliedBookingDiscounts)
              this.appliedBookingDiscounts =
                this.appliedBookingDiscounts.filter((bd) => {
                  return !bd.voucherApplied;
                });

            if (this.bookingDiscounts) {
              this.appliedVouchers = this.bookingDiscounts
                .filter((d: TeeTimeBookingDiscount) => {
                  return (
                    d.voucherApplied &&
                    d.voucherApplied.playerAssigned.id === this.player.id
                  );
                })
                .map((d: TeeTimeBookingDiscount) => {
                  return d.voucherApplied;
                });
            }
          }
        }
      });
  }

  getAssignedPlayerTypes() {
    this.assignedPlayerProfiles = [];
    let _playerId; // = this.player.playerId;
    if (!this.player) return;
    if (this.player) _playerId = this.player.id | this.player.playerId;
    this.flightService
      .assignedBookingPlayerType(_playerId)
      .subscribe((data: Array<PlayerBookingTypeAssociation>) => {
        if (data && data.length > 0) this.assignedPlayerProfiles = data;
      });
  }

  goRemoveProfile(profile) {
    let _bookingPlayerType = profile.bookingPlayerType.id;
    let _playerId = this.player.playerId;
    this.flightService
      .removeBookingPlayerType(_playerId, _bookingPlayerType)
      .subscribe(
        (data) => { },
        (error) => { },
        () => {
          this.getAssignedPlayerTypes();
        }
      );
  }

  async onRemoveProfile(profile) {
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      component: InsuranceModalComponent,
      componentProps: {
        modeFrom:'deleteInsurance',
        headerTitle:'Removing Player Profile',
        message:'Do you want to remove selected player profile?'
      },
      mode: 'ios'
    });

    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data?.data){
        if(data?.data === 'confirm-delete'){
          this.goRemoveProfile(profile);
        }
      }
    })
  }

  getApplicableDiscounts() {
    this.applicableClubDiscount = [];
    let _clubId = this.clubInfo ? this.clubInfo.id : null;
    if (!_clubId) return false;
    if (!this.player) return false;
    let _playerId = this.player.id || this.player.playerId;
    let _playerType = this.bookingPlayer.playerType;
    let _effectiveDate = moment(
      this.currentSlot.slotAssigned.teeOffDate
    ).format('YYYY-MM-DD');
    this.flightService
      .getApplicableDiscountsForPlayer(_clubId, _playerId, _effectiveDate)
      .subscribe((activeClubDiscounts: Array<TeeTimeDiscount>) => {
        if (activeClubDiscounts)
          this.applicableClubDiscount = activeClubDiscounts;
      });
  }

  getProfilePrice(profile) {
    if (!this.currentSlot) return false;
    let _profilePrice;
    let _currency =
      this.currentSlot.clubData.address.countryData.currencySymbol;
    for (let key in this.currentSlot.priceMap) {
      if (profile === key) {
        _profilePrice = this.currentSlot.priceMap[key];
      }
    }
    return _currency + ' ' + this.numberWithCommas(_profilePrice);
  }

  numberWithCommas(x) {
    if (!x) return x;
    else return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  escapeCRLF(value) {
    return JsonService.escapeCRLF(value);
  }

  ionViewWillEnter() {
    this.getAppAttribute();
  }

  ionViewDidEnter() {
    // this.scrollToButton();
  }

  // @ViewChild(IonContent) content: IonContent;
  // @ViewChild('dealsButton', { read: ElementRef }) scrollContainer: ElementRef;
  // scrollToButton() {
  //   let _target = 'target-insurance';
  //   if(this.type) _target = `target-${this.type}`;
  //   console.debug("scrolling to ", this.type)
  //   const button = document.getElementById(_target);
  //   if (button && this.scrollContainer) {
  //     const containerRect = this.scrollContainer.nativeElement.getBoundingClientRect();
  //     const buttonRect = button.getBoundingClientRect();
  //     const scrollLeft = buttonRect.left - containerRect.left + this.scrollContainer.nativeElement.scrollLeft;

  //     this.content.scrollToPoint(scrollLeft, 0, 500);
  //   }
  // }

  showTransferVoucher() {
    if (this.appAttribute && this.appAttribute.showTransferVoucher) return true;
    else return false;
  }

  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe((data: any) => {
      if (data) {
        data
          .filter((d) => {
            return d.page === 'manageVouchers';
          })
          .map((d) => {
            this.appAttribute = d;
          });
      }
    });
  }
  hideExpired: boolean = false;

  checkExpired(voucher) {
    let _voucher: TeeTimeClubVoucher = voucher;
    let _currentDate = moment(); //.add(1, 'days');
    let _voucherUntilDate = moment(_voucher.validUntil, 'YYYY-MM-DD');
    let _diffDays = _voucherUntilDate.diff(_currentDate, 'days');
    //
    // return _voucherUntilDate < _currentDate;
    return _diffDays < 0;
  }

  onSeriesTransferClick(vs: TeeTimeClubVoucherSeries) {
    if (!vs) return;
    if (vs) this.selVoucherSeries = vs;
    this.transferMode = true;
  }

  onPlayerTransferClick(voucher: any) {

    this.onSelectPlayerTransfer(this.selVoucherSeries, voucher);
  }

  async onSelectPlayerTransfer(
    selVoucherSeries: TeeTimeClubVoucherSeries,
    voucher?: any
  ) {

    let _playerModal = await this.modalCtrl.create({
      component: AddPlayerListPage,
      componentProps: {
        fromClub: false,
        openedModal: true,
        noNewPlayer: true,
        transferVoucher: true,
      },
    });
    let _playerId = null;
    _playerId =
      this.player && this.player.playerId
        ? this.player.playerId
        : this.player.id
          ? this.player.id
          : null;

    _playerModal.onDidDismiss().then((data: any) => {
      if (data) {

        if (
          data.data.item &&
          this.player &&
          data.data.item.playerId === _playerId
        ) {
          MessageDisplayUtil.showMessageToast(
            'Please select different player',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return;
        }
        this.goSelectPlayerTransfer(data.data.item, voucher, selVoucherSeries);
        // if(this.player) this.hasPlayer = true;
        // else this.hasPlayer = false;
        // this.selectedPlayer = true;
        // this.selectedVoucher = false;

        // this.getPlayerVoucher(selVoucherSeries);
        // item: item,
        // isCovid: true,
        // newPlayer: _isNewPlayer,
        // playerDetails: this.addPlayerForm.value,
        // playerContact: ''
      } else {
        // this.selectedPlayer = false;
        // this.hasPlayer = false;
      }
    });
    _playerModal.present();
  }

  async goSelectPlayerTransfer(player, voucher: any, selVoucherSeries) {
    let _voucherNumber;
    if (voucher) _voucherNumber = voucher.voucherNumber;
    let prompt = await this.alertCtrl.create({
      header: 'Transfer Voucher',
      message:
        'This will transfer Voucher No. <b>#' +
        _voucherNumber +
        '</b> to the selected player. Do you want to proceed?',
      // '+ _voucherToDelete.length +'
      buttons: [
        {
          text: 'No',
        },
        {
          text: 'Yes',
          handler: () => {
            this.goPlayerTransferVoucher(voucher, player, selVoucherSeries);
          },
          // handler: data => {
          // }
        },
      ],
    });
    prompt.present();
  }

  goPlayerTransferVoucher(voucher, player, selVoucherSeries) {
    let _params = {};
    let _hasError: boolean = false;

    if (!voucher || !player) {
      _hasError = true;
      // MessageDisplayUtil.showMessageToast('Something unexpected occured while transferring. Please try again', this.platform, this.toastCtl,
      // 5000, "bottom");
      // return;
    }
    if (voucher) {
      _params['voucherId'] = voucher ? voucher.id : null;
      _params['clubId'] = voucher ? voucher.club.id : null;
    } else _hasError = true;
    if (player) {
      _params['transferTo'] =
        player && player.id
          ? player.id
          : player.playerId
            ? player.playerId
            : null;
    } else _hasError = true;
    if (this.player) {
      _params['playerId'] =
        this.player && this.player.playerId
          ? this.player.playerId
          : this.player.id
            ? this.player.id
            : null;
    } else _hasError = true;
    if (_hasError) {
      MessageDisplayUtil.showMessageToast(
        'Something unexpected occured while transferring. Please try again',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    this.flightService.transferPlayerVoucher(_params).subscribe(
      (data: any) => {
        if (data) {
          // this.getPlayerVoucher(selVoucherSeries);
          this.setOptionType(3);
          MessageDisplayUtil.showMessageToast(
            'Succesfully transferred voucher',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
        }
      },
      (error) => {
        let _error;
        if (error && error.json()) _error = error.json();

        MessageDisplayUtil.showMessageToast(
          _error.errorMessage,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return;
      }
    );
  }

  listActivePlayerVouchers() {
    let _voucherSeries = this.selVoucherSeries;
    let _vouchers = [];
    if (_voucherSeries)
      _vouchers = this.playerVoucher.filter((voucher: TeeTimeClubVoucher) => {
        return voucher.seriesId === _voucherSeries.id;
      });
    return _vouchers;
  }
  showHcpActiveOnly: boolean = false;
  listHandicapMembership() {
    let _filteredList = [];
    if (
      !this.handicapMembershipList ||
      (this.handicapMembershipList && this.handicapMembershipList.length === 0)
    )
      return _filteredList;
    if (this.showPendingOnly) {
      _filteredList = JsonService.clone(
        this.handicapMembershipList.filter((app) => {
          return !app.approved;
        })
      );
    } else if (this.showHcpActiveOnly) {
      _filteredList = JsonService.clone(
        this.handicapMembershipList.filter((app) => {
          return false;
        })
      );
    } else if (!this.showHcpActiveOnly) {
      _filteredList = JsonService.clone(
        this.handicapMembershipList.filter((app) => {
          return app && (!app.approved || !app.paid);
        })
      );
    } else _filteredList = JsonService.clone(this.handicapMembershipList);

    return _filteredList;
  }

  async onAddHandicapMembership(
    renew?: boolean,
    app?: PartnerProgramMembershipApplication,
    pdp?: PlayerDiscountProgram,
    retryPayment: boolean = false
  ) {
    const modal = await this.modalCtrl.create({
      component: HandicapMembershipAddPage,
      componentProps: {
        player: this.player,
        application: renew ? app : retryPayment ? app : null,
        partnerProgram: renew ? pdp : null,
        retryPayment: retryPayment,
      },
    });

    modal.onDidDismiss().then((data: any) => {
      if (data) {
        if (data.paymentStatus === 'failed' && data.paymentDateTime) {
          if (this.enablePaymentTimer) {
            this.paymentFailed = true;
            this.paymentDateTime = data.paymentDateTime;
          }
        } else {
          this.paymentFailed = false;
          this.paymentDateTime = null;
        }
        if (data.needRefresh) {
          this.setOptionType(5);
        }
      }
    });
    await modal.present();
  }
  loggedInPartnerId: string;
  partnerMembershipApplicationPage: PartnerProgramMembershipApplicationPage;
  handicapMembershipList: Array<PartnerProgramMembershipApplication>;
  onRefreshHandicapMembership() {
    let _playerId; // = this.player.playerId | this.player.id;
    let _params;
    if (!this.fromClub) {
      let _playerId = this.player.playerId | this.player.id;
      _params = {
        partnerId: null,
        programId: null,
        startDate: null,
        endDate: null,
        playerId: _playerId,
        approvedOrNot: false,
        pageSize: 30,
      };
    } else if (this.fromClub) {
      _params = {
        partnerId: this.partnerId,
        programId: null,
        startDate: null,
        endDate: null,
        playerId: null,
        approvedOrNot: null,
        pageSize: 1000,
      };
    }

    this.flightService.listPartnerApplication(_params).subscribe((data) => {
      if (data) {
        this.partnerMembershipApplicationPage = data;
        this.handicapMembershipList = data.items;
      }

    });
  }

  playerInsurancesList: Array<PlayerInsurance>;
  getListPlayerInsurance() {
    let _playerId: number;
    this.playerInsurancesList = [];
    if (this.player) _playerId = this.player.id | this.player.playerId;
    let _params = {};
    this.flightService
      .getPlayerInsurances(_playerId, _params)
      .subscribe((data) => {

        if (data && data.length > 0) {
          this.playerInsurancesList = data;
        }
      });
  }
  getHcpMshipDetails(app: PartnerProgramMembershipApplication, type?: string) {
    // console.debug("get hcp mship details ", app)
    if (!app) return;
    if(!app.partnerProgram) return;
    let _discountProgram = app.partnerProgram;
    let _discountCompany = _discountProgram.discountCompany;
    // if (!app) return;
    switch (type) {
      case 'name':
        return _discountProgram.name;
      case 'membershipNo':
        return app.currentMembershipNumber;
      case 'description':
        return _discountProgram.description;
      case 'company':
        return _discountCompany.name;
      case 'approvedBy':
        return app.approvedBy && app.approvedBy.name;
      case 'approvedAt':
        if (!app.approvedAt) return;
        return moment(app.approvedAt, 'YYYY-MM-DD').format(
          'ddd, DD MMM YYYY'
        );
      case 'date':
        return moment(app.applicationDate, 'YYYY-MM-DD').format(
          'ddd, DD MMM YYYY'
        );
      case 'validity':
        return app.partnerProgram.validityMonths;
      case 'price':
        let _amount = 0;
        if (app.bill && app.bill.billAmount) _amount = app.bill.billAmount;
        else if (app.partnerProgram && app.partnerProgram.discountAmount)
          _amount = app.partnerProgram.discountAmount;
        return (
          app.partnerProgram.discountCompany.country.currencySymbol +
          ' ' +
          _amount
        );
      case 'playerInfo':
        return (
          app.player && app.player.playerName + ' (#' + app.player.id + ')'
        );
      case 'playerEmail':
        return app.email;
      case 'validUntil':
        let _validMonths = app.partnerProgram.validityMonths;
        return moment(app.applicationDate)
          .add(_validMonths, 'months')
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
    }
  }

  onAppRetryPayment(app) {

    if (this.blockPayment()) return;
    this.onAddHandicapMembership(false, app, null, true);
  }
  enablePaymentTimer: boolean = true;
  paymentFailed: boolean = false;
  paymentDateTime: any;
  paymentTimerDuration: number = 5; //in minutes
  blockPayment() {

    // this.enablePaymentTimer = true;

    let _block: boolean = false;
    if (this.enablePaymentTimer) {
      if (this.paymentFailed && this.paymentDateTime) {
        let _currTime = moment();
        let _diffMinutes = _currTime.diff(this.paymentDateTime, 'minutes');

        if (_diffMinutes >= 0 && _diffMinutes < this.paymentTimerDuration) {
          let alert = this.alertCtrl
            .create({
              header: 'Payment',
              // subTitle: 'Selected date is '+ _date,
              message:
                'Your previous payment was not successful or in pending, please try again after ' +
                (this.paymentTimerDuration - _diffMinutes) +
                ' minute(s)', //'Selected date is ' + '<b>' + _date + '</b>',
              buttons: [
                {
                  text: 'OK',
                  handler: () => { },
                },
              ],
            })
            .then((res) => {
              res.present();
              _block = true;
            });
        }
      }
    }
    return _block;
  }
  getAppExpiryDate(app: PartnerProgramMembershipApplication, type?: string) {
    if (!app) return '';
    if (app && !app.partnerProgram.validityMonths) return '';
    if (app && !app.applicationDate) return '';

    let _validFrom = moment(app.applicationDate, 'YYYY-MM-DD');
    let _validTill = moment(app.applicationDate, 'YYYY-MM-DD').add(
      app.partnerProgram.validityMonths,
      'months'
    );

    let _today = moment();
    let _voucher;
    // switch (type) {
    //     default:
    //         let _until = moment(app.validUntil);
    //         if(_until.diff(_today, 'days') < 0) {
    //             _validTill = moment(app.validUntil);
    //             _validFrom = moment(app.validFrom);
    //         } else if(_voucher && _voucher.length > 0) {
    //             _validTill = moment(_voucher[0].validUntil);
    //             _validFrom = moment(_voucher[0].validFrom);
    //         } else {
    //             _validTill = moment(app.validUntil);
    //             _validFrom = moment(app.validFrom);
    //         }
    //         break;
    // }
    let _days = _validTill.diff(_today, 'days');
    let _months = _validTill.diff(_today, 'months');
    let _years = _validTill.diff(_today, 'years');
    if (_days > 0 && _months === 0) return 'Expires in ' + _days + ' day(s)';
    else if (_months > 0 && _years === 0)
      return 'Expires in ' + _months + ' month(s)';
    else if (_years > 0 && _years <= 100)
      return 'Expires in ' + _years + ' year(s)';
    else if (_years > 100) return 'No Expiry';
    else if (_days === 0) return 'Expires today';
    else if (_days < 0) return 'Expired';
    else return 'Expired';
    // return _started + ' | ' + _expireText + 'days';
  }
  getInsuranceExpiryDate(item: PlayerInsurance, type?: string) {
    if (!item) return '';
    if (item && !item.startDate && !item.endDate) return '';
    let _validTill;
    let _validFrom;
    _validTill = moment(item.endDate);
    _validFrom = moment(item.startDate);

    let _today = moment();
    let _voucher;
    if (
      this.playerVoucher &&
      this.playerVoucher.length > 0 &&
      type !== 'discount'
    ) {
      _voucher = this.playerVoucher.filter((voucher) => {
        return voucher.seriesId === item.id;
      });
    }
    let _until = moment(item.endDate);
    switch (type) {
      case 'discount':
        _validTill = moment(item.endDate);
        _validFrom = moment(item.startDate);
        break;
      default:
        if (_until.diff(_today, 'days') < 0) {
          _validTill = moment(item.endDate);
          _validFrom = moment(item.startDate);
        } else if (_voucher && _voucher.length > 0) {
          // _validTill = moment(_voucher[0].validUntil);
          // _validFrom = moment(_voucher[0].validFrom);
        } else {
          _validTill = moment(item.endDate);
          _validFrom = moment(item.startDate);
        }
        break;
    }
    //
    // let _started = _validFrom.diff(_today, 'days');
    let _days = _validTill.diff(_today, 'days');
    let _months = _validTill.diff(_today, 'months');
    let _years = _validTill.diff(_today, 'years');

    if (_days > 0 && _months === 0) return 'Expires in ' + _days + ' day(s)';
    else if (_months > 0 && _years === 0)
      return 'Expires in ' + _months + ' month(s)';
    else if (_years > 0 && _years <= 100)
      return 'Expires in ' + _years + ' year(s)';
    else if (_years > 100) return 'No Expiry';
    else if (_days === 0) return 'Expires today';
    else if (_days < 0) return 'Expired';
    else return 'Expired';
  }
  getInsuranceDetails(insurance: PlayerInsurance, type?: string) {
    if (!insurance) return;
    let _playerInsurance = insurance;
    let _partnerCompany = null;
    if (_playerInsurance && _playerInsurance.partner)
      _partnerCompany = _playerInsurance.partner;
    let _applicableInLength;
    let _applInText = '';
    if (_playerInsurance.applicableIn)
      _applicableInLength = _playerInsurance.applicableIn.length;
    if (_applicableInLength <= 0) _applInText = '';
    else if (_applicableInLength === 1)
      _applInText = 'Applicable in <b>' + _applicableInLength + '</b> country';
    else
      _applInText =
        'Applicable In <b>' + _applicableInLength + '</b> countries';

    switch (type) {
      case 'name':
        return _playerInsurance.name;
      case 'insuranceNo':
        return _playerInsurance.insuranceNo;
      case 'description':
        return _playerInsurance.description;
      case 'company':
        return _partnerCompany && _partnerCompany.name
          ? _partnerCompany.name
          : null;
      case 'applicableIn':
        return _applicableInLength;
      case 'applicableInText':
        return _applInText;
    }
  }
  hasInsuranceChanged: boolean = false;

  onHasInsuranceClick() {
    this.hasInsuranceChanged = true;
    let _bookingId = this.currentSlot.id;
    // this.playerHasInsurance = !this.playerHasInsurance;
    // this.bookingPlayer.playerHasInsurance = this.playerHasInsurance;
    let _bookingPlayer = this.bookingPlayer;

    this.flightService
      .updateBookingPlayerDetails(_bookingId, _bookingPlayer, 'hasInsurance')
      .subscribe((data: any) => {

        // this.refreshBookingDetails();
        if (data) {
          MessageDisplayUtil.showMessageToast(
            'Successfully updated booking player',
            this.platform,
            this.toastCtl,
            3000,
            'bottom'
          );
          return false;
        }
      });
  }
  selectedFiles: any = [];
  temporaryImageURL: string;
  previewImage: Array<any>;
  async takePhotoFromGallery(event, pdp, mode?: string) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    this.selectedFiles = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);

        //
      }
      this.temporaryImageURL = event.target.files[0].name;

      this.previewImage = images;
      if (this.selectedFiles && mode === 'update')
        this._uploadImage(this.temporaryImageURL, pdp);
    }
  }
  async onApplyVoucherToOthers(
    voucher: TeeTimeClubVoucherSeries,
    apply?: boolean
  ) {
    let _players;
    let _currentPlayer;
    let _currentVoucher: TeeTimeClubVoucher;
    if (
      this.fromClub &&
      this.appAttribute &&
      !this.appAttribute.allowClubToTransferApply
    ) {
      MessageDisplayUtil.showErrorToast(
        'This feature is currently disabled for club',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    if (this.playerVoucher)
      _currentVoucher = this.playerVoucher
        .filter((playerVoucher: TeeTimeClubVoucher) => {
          return playerVoucher.seriesId === voucher.id;
        })
        .sort((a: TeeTimeClubVoucher, b: TeeTimeClubVoucher) => {
          if (a.id > b.id) return -1;
          else if (a.id < b.id) return 1;
          return 0;
        })
        .pop();
    //  map((playerVoucher: TeeTimeClubVoucher) =>{
    //     return playerVoucher
    // })

    if (this.player) {
      _currentPlayer = this.player;
    }
    if (this.currentSlot) {
      _players = this.currentSlot.bookingPlayers.filter(
        (tbp: TeeTimeBookingPlayer) => {
          return tbp.player && tbp.player.id !== _currentPlayer.id;
        }
      );
    }
    if ((_players && _players.length === 0) || !_players) {
      MessageDisplayUtil.showErrorToast(
        'There is no other players in the booking. Please make sure they are registered as myGolf2u players.',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      return;
    }
    let popover: any = await this.popoverCtl.create({
      component: PlayerListPage,
      componentProps: {
        // slot: slot,
        headerName: 'Available Booking Players',
        playerList: _players,
        forResultOnly: true,
        forVoucher: true,
        // buggies: this.buggySlots,
        // courses: this.courses
      },
      showBackdrop: true,
    });
    popover.onDidDismiss().then(async (data: any) => {

      if (data && data.selected) {

        let _selectedPlayer = data.player;
        let _voucherId = _currentVoucher.id;
        let _bookingId = this.currentSlot.id;
        let _params = {
          bookingId: _bookingId,
          voucherId: _voucherId,
          playerId: _selectedPlayer.player.id,
        };

        let _buttons = [
          {
            text: 'Cancel',
          },
          {
            text: 'Apply',
            handler: () => {
              _params['force'] = false;
              this.goApplyVoucherToOthers(voucher, _params);
            },
          },
        ];
        if (
          this.fromClub &&
          this.appAttribute &&
          this.appAttribute.clubForceApply
        ) {
          _buttons.push({
            text: 'Force apply',
            handler: () => {
              _params['force'] = true;
              this.goApplyVoucherToOthers(voucher, _params);
            },
          });
        }
        let prompt = await this.alertCtrl.create({
          header: 'Transfer and Apply Voucher',
          message:
            'This will transfer and apply voucher to the selected player. This process is irreversible until the player is logged in and undo. Do you want to proceed?',
          buttons: _buttons,
        });
        prompt.present();



        // this.checkBookingPlayer(data.player).then((playerOk) => {

        //     if (playerOk) this.addPlayerToBooking({
        //         playerId: data.player.id,
        //         sequence: slot,
        //         playerDetails: _playerDetails,
        //     });
        // })
      }
    });
    popover.present({
      ev: event,
    });
  }
  goApplyVoucherToOthers(voucher: TeeTimeClubVoucherSeries, params: any) {
    let _params = params;
    this.flightService.transferAndApplyPlayerVoucher(_params).subscribe(
      (data) => {

        let _message = '';
        _message = 'Successfully applied voucher to selected player';
        MessageDisplayUtil.showMessageToast(
          _message,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        this.setOptionType(3);
        this.isVoucherApplied = true;
        // return;
      },
      (error) => {
        let _error;
        if (error && error) _error = error;

        MessageDisplayUtil.showErrorToast(
          _error.errorMessage,
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return;
      }
    );
  }

  async modalOpen(pdp: PlayerDiscountProgram, type?: string){
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      component: InsuranceModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        modeFrom:'insuranceAction'
      },
      mode: 'ios'
    });

    await modal.present();

     modal.onDidDismiss().then((data)=>{
      if(data?.data){
        if(data?.data === 'edit'){
          this.onEditClick(pdp,type)
        }
        else if(data?.data === 'delete'){
          console.log("DELETE")
          this.deleteinsuranceModal(pdp,type)
        }
      }
     })
  }

  async deleteinsuranceModal(pdp: PlayerDiscountProgram, type?: string){

    let headerTitle;
    let message;
    switch (type) {
      case 'playerType':
        headerTitle = 'Removing Player Type';
        message = 'Do you want to remove selected Player Type?';
        break;
      case 'playerDiscount':
        headerTitle = 'Removing Discount Card';
        message =
          'You will lose privilege/discount deals by the club. Do you want to proceed?';
        break;
      case 'playerVoucher':
        headerTitle = 'Removing Voucher';
        message = 'Do you want to remove selected Voucher?';
        break;
      case 'playerInsurance':
        headerTitle = 'Removing Insurance';
        message = 'Do you want to remove selected Insurance?';
        break;
    }

    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      component: InsuranceModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        modeFrom:'deleteInsurance',
        headerTitle:headerTitle,
        message:message
      },
      mode: 'ios'
    });

    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data?.data){
        if(data?.data === 'confirm-delete'){
          this.onRemoveClick(pdp,'playerInsurance')
        }
      }
    })
  }

  async actionMenu(pdp: PlayerDiscountProgram){
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      component: InsuranceModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        modeFrom:'privilege-card',
      },
      mode: 'ios'
    })
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data?.data){
        if(data?.data === 'edit'){
          this.onEditClick(pdp,'playerDiscount')
        }
        else if(data?.data === 'delete'){
          this.onRemoveClick(pdp,'playerDiscount')
        }
      }
     })
  }

  async infoModal(data:string,app: PartnerProgramMembershipApplication){
    console.log('app: ', app);

    let _discountProgram = app.partnerProgram;
    let validUntill = app.partnerProgram.validityMonths

    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      component: InsuranceModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        modeFrom:data,
        headerTitle:'Information',
        infoDescription: _discountProgram.description,
        validToDate:moment(app.applicationDate, 'YYYY-MM-DD').format('DD MMM YYYY'),
        validUntillDate: moment(app.applicationDate).add(validUntill, 'months').subtract(1, 'days').format('DD MMM YYYY')
      },
      mode: 'ios'
    })
    await modal.present();
  }

  async _pdpInfoModal(data:string,pdp: any){
    let _discountProgram = pdp.discountProgram;
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      showBackdrop:true,
      component: InsuranceModalComponent,
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        modeFrom:data,
        headerTitle:'Information',
        infoDescription: _discountProgram.description,
        validToDate:moment(pdp.validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
        validUntillDate: moment(pdp.validUntil).format('DD MMM YYYY')
      },
      mode: 'ios'
    })
    await modal.present();
  }


  hasProgramApplication(pdp) {
    // console.debug('hasProgram application', pdp)
    // console.debug('hasProgram application', pdp.applicationCreated || pdp.applicationRenewed)
    if(!pdp) return;
    if(pdp.discountProgram && pdp.discountProgram.includesHandicap) {
        return true
    }

    // if(pdp.applicationCreated === undefined) return;
    // if(pdp.applicationRenewed === undefined) return;
    return pdp.applicationCreated || pdp.applicationRenewed;

}

getVoucherSeries() {
  let _voucherList = [];
  if(!this.voucherSeries) return _voucherList;
  if(this.voucherSeries.length === 0) return _voucherList;
      _voucherList = this.voucherSeries.filter((vs)=>{
          return vs.applicableIn.some((app)=>{ return app.toLowerCase() === this.voucherTypes});
      });
      // console.debug("get voucher series [0] : ", this.voucherSeries, this.voucherTypes);
      // console.table("get voucher series [1] : ",_voucherList);
  return _voucherList;
}


getFilteredVoucher() {
  let _filteredVoucher = [];
  if(!this.voucherSeries) return _filteredVoucher;
  if(this.voucherSeries.length === 0) return _filteredVoucher;
  if(!this.playerVoucher) return _filteredVoucher;
  if(this.playerVoucher.length === 0) return _filteredVoucher;

  let _voucherSeries = this.voucherSeries.filter((vs)=>{
      return vs.applicableIn.some((app)=>{ return app.toLowerCase() === this.voucherTypes});
  })
  _filteredVoucher = this.playerVoucher.filter((pv)=>{
      return _voucherSeries.some((vs)=>{ return pv.seriesId === vs.id});
  });
  console.debug("get filtered voucher [0]: ", this.voucherTypes, _voucherSeries,_filteredVoucher);
  console.debug("get filtered voucher [1]: ", this.voucherTypes, this.voucherSeries, this.playerVoucher);
  return _filteredVoucher;
}

  getVoucherDetails(voucher: TeeTimeClubVoucher, attribute: string) {
    if(!voucher) return;
    if(!this.voucherSeries) return;
    let _voucherSeries: TeeTimeClubVoucherSeries;
    this.voucherSeries.filter((vs)=>{
        return voucher.seriesId === vs.id;
    }).map((vs)=>{
        _voucherSeries = vs;
    })
    switch(attribute) {
        case 'tbooking':
            if(!voucher.remarks) return;
            if(voucher.remarks.length === 0) return;
            if(!voucher.remarks.split(':', 2)) return;
            let _refNo = voucher.remarks.split(':', 2)[1];
            return _refNo
        case 'name':
            return voucher.name;
        case 'validFrom':
            return moment(voucher.validFrom,"YYYY-MM-DD").format('DD MMM YYYY');
        case 'validTo':
            return moment(voucher.validUntil,"YYYY-MM-DD").format('DD MMM YYYY');
        case 'allowDays':
            let _allowText = '';
            let _applicableStart = 'Applicable on ';
            let _allowWeekdays = '';
            let _allowWeekends = '';
            let _allowHolidays = '';

            _allowWeekdays = (voucher && voucher.allowOnWeekdays && (voucher.allowOnWeekends && voucher.allowOnPublicHolidays) ? 'Weekdays' + ', ' : voucher && voucher.allowOnWeekdays ? 'Weekdays' : '');
            _allowWeekends = (voucher && voucher.allowOnWeekends && (voucher.allowOnWeekdays) && voucher.allowOnPublicHolidays)? 'Weekends' : (voucher && voucher.allowOnWeekdays && voucher.allowOnWeekends && !voucher.allowOnPublicHolidays) ? ' and ' + 'Weekends' : (voucher && !voucher.allowOnWeekdays && voucher.allowOnWeekends)?'Weekends':'';
            _allowHolidays = (voucher && ((voucher.allowOnWeekdays || voucher.allowOnWeekends) && voucher.allowOnPublicHolidays) ? ' and ' + 'Public Holidays' : voucher && voucher.allowOnPublicHolidays ? 'Public Holidays' : '');

            _allowText =
            _applicableStart +
            _allowWeekdays +
            _allowWeekends +
            _allowHolidays;
            return _allowText;
        case 'voucherNumber':
            return voucher.voucherNumber;
        case 'validDays':
            let _days = moment(voucher.validUntil,"YYYY-MM-DD").diff(moment(voucher.validFrom,"YYYY-MM-DD"), 'days');
            return 'Validity <b>' + _days + '</b> days';
        case 'seriesName':
            return _voucherSeries.name;
        case 'image':
            return _voucherSeries.voucherImage;
        case 'amount':
            return voucher.voucherAmount;


    }
  }

  totalVouchers: number = 0;
  totalPageVouchers: number = 0;
  currentPageVoucher: number = 1;
  getPlayerVouchers(refresher?, infinite?) {
    let _playerId: number;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _playerId = player.playerId
        // this.currentPlayer = player
    });
    //  = this.player$.pipe(map((playerInfo: PlayerInfo) => {
    //   console.debug("get player voucher id ", playerInfo)
    //   return playerInfo?.id || playerInfo?.playerId;
    // }));
    let _params;
    if(this.voucherView === 'expired') {
      _params = {
        includeExpired: true,
        excludeFuture: true,
      }
    } else if(this.voucherView === 'redeemed') {
      _params = {
        includeRedeemed: true,
        excludeFuture: true
      }
    } else {

    }
    if(!infinite) {
      this.currentPageVoucher = 0;
      this.totalPageVouchers = 0;
      this.playerVoucher = [];
    }
    _params = Object.assign({}, _params, {
      playerId: _playerId,
      applicable: this.voucherTypes,
      clubId: this.clubData?.clubId || this.clubData?.id,
      pageSize: 5,
      pageNo: this.currentPageVoucher+1
    })

    this.flightService.getPlayerVouchers(_params)
    .subscribe((data: TeeTimeClubVoucherPage) => {
      if(data) {
        this.totalVouchers = data?.totalItems;
        this.totalPageVouchers = data?.totalPages;
        this.currentPageVoucher = data?.currentPage
      }
      if(data?.items) {
        this.playerVoucher.push(...data?.items);
        // this.playerVoucher = data?.items;
      }
    },(error)=>{
      if (refresher) {
          refresher.target.complete();
      }
      if (infinite) {
          infinite.target.complete();
      }
    },()=>{
      if (refresher) {
        refresher.target.complete();
      }
      if (infinite) {
          infinite.target.complete();
      }
    })
  }

  async onClickChangeVoucherView() {
    if(this.mode === 'apply') return;
    let _dataList = [{
    id: 'available',
    name: 'Available Vouchers',
    // iconUrl: 'assets/icons/golf-website.png'
  },{
    id: 'redeemed',
    name: 'Redeemed Vouchers',
    // iconUrl: 'assets/icons/book.png'
  },{
    id: 'expired',
    name: 'Expired Vouchers',
    // iconUrl: 'assets/icons/golf-field.png'
  }]
    const modal = await this.modalCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          dataList: _dataList,
          mode: 'common',
          headerTitle: 'Select which vouchers to view',
          // subTitle: this.leagueRounds?this.leagueRounds[0].seasonName:'',
      }
  })
  await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
  });
  modal.onDidDismiss().then((data: any) => {
    console.debug("pullup dismiss", data)
    if(data) {
      this.voucherView = data?.data?.id
      this.getPlayerVouchers();
      // if(data?.data?.id === 'available') {
      //   this.voucherView = ''
      //   this.getPlayerVouchers();
      // } else if(data?.data?.id === 'redeemed') {
      //   this.goLeagueScorecard();
      // } else if(data?.data?.id === 'expired') {
      //   this.goLeagueLowestLeaderboard();
      // }
    }
    // if(data)

  })
  }

  isAllVouchersAvailable() {
    if(this.voucherView === 'available' && this.playerVoucher?.length > 0) {
      return true;
    } else if(this.voucherView !== 'available' && this.getFilteredVoucher()?.length > 0) {
      return true;
    } else return false;
  }


  doInfinite(infinite) {
    console.log('infinite: ', infinite);
    if (this.isMore()) {
      if(this.optionTypes === 'voucher')
        this.getPlayerVouchers(null, infinite);
    } else {
        infinite.target.complete();
        infinite.target.disabled = true;
    }

  }

  public isMore() {
      // return false
    if(this.optionTypes === 'voucher') {

      return this.currentPageVoucher > 0 && this.currentPageVoucher < this.totalPageVouchers;
      // return this.playerList.totalPages > 0 && this.playerList.currentPage < this.playerList.totalPages;
    }
  }
}
